<template>
  <!-- 派单管理 -->
  <div class="billOperationRecord public_Spacing">
    <div class="pulbic_oparetionBlock dispatch-filter-card">
      <div class="dispatch-section-head">
        <div>
          <h3 class="dispatch-section-title">派单筛选</h3>
          <p class="dispatch-section-desc">支持按企业、客户、物料、状态和快捷日期组合筛选，先用快捷日期缩小范围会更高效。</p>
        </div>
        <span v-if="activeFilterCount" class="dispatch-section-meta">已选 {{ activeFilterCount }} 项筛选</span>
      </div>
      <div class="public_criteriaRange">
        <div class="dispatch-filter-group-title">主要筛选</div>
        <div v-shiroHiden="solelist" id="企业筛选">
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">企业：</label>
            <el-select class="public_optionSty dropDown_Define" @change="erpChange" v-model="enterpriseTwo"
              placeholder="请选择" filterable clearable remote :remote-method="filterEnterprise">
              <el-option v-for="item in filteredEnterpriseOptions" :key="item.SETTB99ID" :label="item.SETTB99CA00"
                :value="item.SETTB99ID">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="public_oparetionBlock_Menu" v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'">
          <label class="public_lbSty">客户：</label>
          <el-select class="public_optionSty dropDown_Define" v-model="customerMo" placeholder="请选择" filterable clearable remote :remote-method="filterCustomer">
            <el-option v-for="item in filteredCustomerOptions" :key="item.ORMTB410ID" :label="item.ORMTB410CA00"
              :value="item.ORMTB410ID">
            </el-option>
          </el-select>
        </div>
        <div v-shiroHiden="solelist" id="物料筛选">
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">物料：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="materielMo" placeholder="请选择" filterable>
              <el-option v-for="item in materielOptions" :key="item.SETTB109ID" :label="item.SETTB109CA00"
                :value="item.SETTB109ID">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">状态：</label>
          <el-select class="public_optionSty dropDown_Define" v-model="SETTB122CA07" placeholder="请选择">
            <el-option v-for="item in dataStatusOperation" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">车牌号：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <input class="pulic_carNumber" type="text" placeholder="请输入" v-model="carNumber" />
            </div>
          </div>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">派单号：</label>
          <div class="el-select public_optionSty">
            <div class="el-input el-input--suffix">
              <input class="pulic_carNumber" type="text" placeholder="请输入" v-model="ORMTB440CA00" />
            </div>
          </div>
        </div>
        <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty">时间：</label>
          <el-select class="public_optionSty dropDown_Define" v-model="timeType" placeholder="请选择">
            <el-option label="派单时间" value="1"> </el-option>
            <el-option label="结算时间" value="2"> </el-option>
          </el-select>
        </div>
        <template v-if="secondaryFilterVisible">
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">代下单：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="ORMTB440CA29" placeholder="请选择">
              <el-option v-for="item in orOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">离线订单：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="lxorde" placeholder="请选择">
              <el-option v-for="item in orlxOrdeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">修改订单：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="xgorde" placeholder="请选择">
              <el-option v-for="item in orXgOrdeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">错单：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="cdorde" placeholder="请选择">
              <el-option v-for="item in orCdOrdeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </template>
        <div class="dispatch-filter-toggle" @click="secondaryFilterVisible = !secondaryFilterVisible">
          <span>{{ secondaryFilterVisible ? '收起筛选' : '更多筛选' }}</span>
          <i :class="secondaryFilterVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
        </div>
        <!-- <div class="public_oparetionBlock_Menu">
          <label class="public_lbSty" style="width:120px">运单信息展示：</label>
          <el-select class="public_optionSty dropDown_Define" v-model="areaOpen" placeholder="请选择">
            <el-option v-for="item in areaOpenOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div> -->
      </div>
      <div class="public_operatArea dispatch-date-row">
        <span class="dispatch-date-label">快捷时间</span>
        <span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive ? 'public_dateActive' : ''"
          @click="getNowDay">当日</span>
        <span class="public_operatArea_yesterday pulic_cursor" :class="dateYesterdayActive ? 'public_dateActive' : ''"
          @click="getYesterday">昨天</span>
        <span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive ? 'public_dateActive' : ''"
          @click="sameMonth">当月</span>
        <span class="public_operatArea_yesterday pulic_cursor" :class="dateLastMonthActive ? 'public_dateActive' : ''"
          @click="lastMonth">上月</span>
        <div class="public_operatArea_timePicker pulic_cursor">
          <el-date-picker v-model="date" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
            :picker-options="startDateDisabled" @change="datePickerChange" start-placeholder="开始日" end-placeholder="结束日"
            class="pulic_cursor">
          </el-date-picker>
        </div>
        <span class="dispatch-date-meta">当前按{{ timeType == '2' ? '结算时间' : '派单时间' }}筛选</span>
      </div>
      <div class="dispatch-action-row">
        <div v-if="secondaryFilterVisible" class="public_criteriaRange dispatch-secondary-filters">
          <div class="dispatch-filter-group-title dispatch-filter-group-title-secondary">补充筛选</div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">订单类别：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="orderCategory" placeholder="请选择">
              <el-option v-for="item in orderCategoryOpenOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="public_oparetionBlock_Menu">
            <label class="public_lbSty">订单出处：</label>
            <el-select class="public_optionSty dropDown_Define" v-model="orderSource" placeholder="请选择">
              <el-option v-for="item in orderSourceOpenOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="public_operatBtn dispatch-operat-btn">
          <button @click="queryClick()" class="public_saleWater_chaxun pulic_cursor dispatch-query-btn" v-shiroHiden="solelist" id="查询">
            <i class="iconfont icon-chaxun"></i>查询
          </button>
          <el-button class="dispatch-reset-btn" plain @click="resetFilters">重置筛选</el-button>
          <!-- 	<button @click="playVoice" class="public_saleWater_chaxun pulic_cursor" v-shiroHiden="solelist"
							id="查询"><i class="iconfont icon-chaxun"></i>播放语音</button> -->
          <el-button class="public_saleWater_daochu pulic_cursor dispatch-utility-btn" :loading="loadingBut" @click="exports"
            v-shiroHiden="solelist" id="导出"><i class="iconfont icon-daochu"></i>导出<span v-if="confirmTxt > 0">{{
              confirmTxt }}</span></el-button>
          <button @click="stuUpdjd" class="public_saleWater_xinzeng pulic_cursor dispatch-utility-btn" v-shiroHiden="solelist" id="状态同步">
            <i class="iconfont icon-chaxun"></i>状态同步
          </button>
          <el-popover ref="popover2" trigger="click">
            <div style="text-align: left;padding-left: 20px;padding-top: 8px;">
              <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                @change="handleCheckAllChange">全选</el-checkbox>
              <div style="margin: 15px 0;"></div>
              <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                <el-checkbox style="display: block;" class="salesWater_checkbox" v-for="city in cities" :label="city"
                  :key="city">{{ city }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <button slot="reference" class="public_saleWater_chaxun pulic_cursor dispatch-utility-btn">
              <i class="iconfont icon-shezhi"></i>列设置
            </button>
          </el-popover>
        </div>
      </div>
    </div>
    <div v-shiroHiden="solelist" id="统计" class="dispatch-section-wrap">
      <div class="dispatch-section-head">
        <div>
          <h3 class="dispatch-section-title">派单统计</h3>
          <p class="dispatch-section-desc">统计结果会随当前筛选条件和时间范围同步刷新。</p>
        </div>
        <span class="dispatch-section-meta">{{ refreshStatusText }}</span>
      </div>
      <div class="dispatch-stats-bar" v-loading="statsLoading && hasLoadedOnce">
        <div class="dispatch-stats-item">
          <span class="dispatch-stats-label">派单车次</span>
          <span class="dispatch-stats-value dispatch-stats-value--blue">{{ formatMetricValue(pdcc) }}</span>
          <span class="dispatch-stats-unit">单</span>
        </div>
        <div class="dispatch-stats-divider"></div>
        <div class="dispatch-stats-item">
          <span class="dispatch-stats-label">结算车次</span>
          <span class="dispatch-stats-value">{{ formatMetricValue(jscc) }}</span>
          <span class="dispatch-stats-unit">单</span>
        </div>
        <div class="dispatch-stats-divider"></div>
        <div class="dispatch-stats-item">
          <span class="dispatch-stats-label">派单金额</span>
          <span class="dispatch-stats-value dispatch-stats-value--green">{{ formatMetricValue(pdje) }}</span>
          <span class="dispatch-stats-unit">元</span>
        </div>
        <div class="dispatch-stats-divider"></div>
        <div class="dispatch-stats-item">
          <span class="dispatch-stats-label">结算金额</span>
          <span class="dispatch-stats-value">{{ formatMetricValue(jsje) }}</span>
          <span class="dispatch-stats-unit">元</span>
        </div>
        <div class="dispatch-stats-divider"></div>
        <div class="dispatch-stats-item">
          <span class="dispatch-stats-label">派单重量</span>
          <span class="dispatch-stats-value dispatch-stats-value--orange">{{ formatMetricValue(pdzl) }}</span>
          <span class="dispatch-stats-unit">吨</span>
        </div>
        <div class="dispatch-stats-divider"></div>
        <div class="dispatch-stats-item">
          <span class="dispatch-stats-label">结算重量</span>
          <span class="dispatch-stats-value">{{ formatMetricValue(jszl) }}</span>
          <span class="dispatch-stats-unit">吨</span>
        </div>
      </div>
    </div>
    <div class="billOperationRecord-table pulbic_table_container">
      <div class="dispatch-section-head dispatch-table-head">
        <div>
          <h3 class="dispatch-section-title">订单明细</h3>
          <p class="dispatch-section-desc">点击任意订单行或派单号可查看订单详情，更多字段可通过列设置按需展开。</p>
        </div>
        <div class="dispatch-table-tools">
          <span class="dispatch-table-tip">点击行查看详情，点击右侧更多处理订单</span>
          <span class="dispatch-table-meta">共 {{ pagingPageMo || 0 }} 条 · {{ refreshStatusText }}</span>
        </div>
      </div>
      <el-table ref="dispatchTable" v-loading="tableLoading && hasLoadedOnce" tooltip-effect="dark" :data="tableData" style="width: 100%;"
        :default-sort="{ prop: 'waterNum', order: 'descending' }" @row-click="handleDispatchRowClick" :header-cell-style="{
          color: 'rgba(51,51,51,1)',
          background: 'rgba(184,227,255,1)',
          'font-weight': 'bold',
        }" class="public_tableColumn">
        <el-table-column prop="ORMTB440CA19" sortable fixed="left" width="170">
          <template slot="header">
            <span>派单信息</span>
            <el-tooltip content="点击派单号或表格任意一行可查看订单详情" placement="top">
              <i class="el-icon-info dispatch-header-tip"></i>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <p class="dispatch-cell-main">{{ scope.row.ORMTB440CA19 }}</p>
            <el-tooltip content="点击查看订单详情" placement="top">
              <button type="button" class="dispatch-detail-link" @click.stop="DetailsClick(scope.row)">{{ scope.row.ORMTB440CA00 }}</button>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="ORMTB440CA03" label="客户信息">
          <template slot-scope="scope">
            <div class="dispatch-cell-block dispatch-cell-block-customer">
              <div class="dispatch-customer-info">
                <div class="dispatch-customer-name">{{ scope.row.ORMTB440CA03 }}</div>
                <div class="dispatch-customer-phone" v-if="scope.row.ORMTB410CA02">{{ scope.row.ORMTB410CA02 }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="ORMTB440CA01" min-width="190" label="运输信息">
          <template slot-scope="scope">
            <div class="dispatch-cell-block dispatch-cell-block-transport">
              <p class="dispatch-cell-main">{{ scope.row.ORMTB440CA01 }}</p>
              <div class="dispatch-cell-sub-list">
                <p class="dispatch-cell-sub dispatch-cell-sub-chip dispatch-cell-sub-chip-factory" v-if="scope.row.ORMTB440CA05">{{ scope.row.ORMTB440CA05 }}</p>
                <p class="dispatch-cell-sub dispatch-cell-sub-chip dispatch-cell-material-row">
                  <span class="dispatch-material-title">物料</span>
                  <span>订单 {{ scope.row.ORMTB440CA07 || '--' }}</span>
                  <span>出厂 {{ scope.row.ORMTB440CC02 || '--' }}</span>
                </p>
                <p class="dispatch-cell-sub dispatch-cell-sub-chip dispatch-cell-sub-weight dispatch-weight-row">
                  <span class="dispatch-weight-title">重量</span>
                  <span>派单 {{ formatMetricValue(scope.row.ORMTB440CA10) }}</span>
                  <span>结算 {{ formatMetricValue(scope.row.ORMTB440CC04) }}</span>
                  <span v-if="scope.row.type != 1">卸货 {{ formatMetricValue(scope.row.ORMTB440CE09) }}</span>
                </p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-for="item in tableHeadList" :min-width="item.width || 110" :prop="item.prop"
          :label="item.label" :key="item.prop" show-overflow-tooltip>
        </el-table-column>
        <el-table-column min-width="190" label="状态">
          <template slot-scope="scope">
            <div class="dispatch-status-card">
              <span class="dispatch-status-primary">{{ scope.row.ORMTB440CF01text }}</span>
              <div class="dispatch-status-list">
                <span>审核：{{ scope.row.auditText }}</span>
                <span :class="scope.row.msgFlag == 0 ? 'dispatch-status-chip-normal' : 'dispatch-status-chip-alert'">
					<!-- 消息：{{ scope.row.msgFlag == 0 ? '正常' : '失败' }} -->
					</span>
                <span>代下：{{ scope.row.ORMTB440CA29 == 1 ? '是' : '否' }}</span>
                <span :class="scope.row.ORMTB440CA38 == 1 ? 'dispatch-status-chip-alert' : 'dispatch-status-chip-normal'">{{ scope.row.ORMTB440CA38 == 1 ? '已冻结' : '未冻结' }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="150" label="类型/标记">
          <template slot-scope="scope">
            <div class="dispatch-type-cell">
              <span :class="[scope.row.type == 1 ? 'orderBtnType1' : 'orderBtnType2', 'orderBtn']">{{ scope.row.type == 1 ? '自提' : '运输' }}</span>
              <span :class="[scope.row.source == 0 ? 'orderBtn2' : 'orderBtn1', 'orderBtn']">{{ scope.row.source == 0 ? '客户' : '平台' }}</span>
              <img v-if="scope.row.ORMTB440CN00 == '1' && uobj.pertb005.pertb005cb00 == 'CUS-1'" class="imgStatistics" src="../../assets/images/orderStatistics/xg.png" />
              <img v-if="scope.row.ORMTB440CN05 && uobj.pertb005.pertb005cb00 == 'CUS-1'" class="imgStatistics" src="../../assets/images/orderStatistics/cd.png" />
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="this.uobj.pertb005.pertb005cb00 == 'CUS-1'" label="操作" fixed="right" width="120">
          <template slot-scope="scope">
            <div class="dispatch-table-actions" @click.stop>
              <el-dropdown v-if="hasDispatchActions(scope.row)" trigger="click" @command="handleDispatchAction($event, scope.row)">
                <el-button type="primary" size="small" class="dispatch-more-btn">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown" class="dispatch-action-menu">
                  <el-dropdown-item v-if="
                    scope.row.ORMTB440CF01 == '-2' &&
                    scope.row.ORMTB440CG00 == 0
                  " command="auditCancel" id="审核取消" v-shiroHiden="solelist">审核取消</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.isauditOrder == 1" command="auditDispatch" id="审核派单"
                    v-shiroHiden="solelist">审核派单</el-dropdown-item>
                  <el-dropdown-item v-if="
                    scope.row.ORMTB440CF01 == 4 &&
                    scope.row.ORMTB440CF00 == 'ZG'
                  " command="receipt" id="确认回执" v-shiroHiden="solelist">确认回执</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ORMTB440CA29 == 1 && scope.row.ORMTB440CA30 == 0"
                    command="pushMsg" id="推送支付消息">推送支付消息</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ORMTB440CA29 == 1 && scope.row.ORMTB440CA30 == 0"
                    command="settlement" id="结算">结算</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ORMTB440CA29 == 1" command="qrCode">查看二维码</el-dropdown-item>
                  <el-dropdown-item v-if="
                    scope.row.ORMTB401CA01 === 'ZJ' &&
                    scope.row.ORMTB440CF01 >= 0 &&
                    scope.row.ORMTB440CF01 < 3
                  " command="uploadQr">上传二维码</el-dropdown-item>
                  <el-dropdown-item v-if="
                    (scope.row.ORMTB401CA01 == 'ZJ' ||
                      scope.row.ORMTB440CA42 == '1') &&
                    (scope.row.ORMTB440CF01 == 0 ||
                      scope.row.ORMTB440CF01 == 2 ||
                      scope.row.ORMTB440CF01 == 6)
                  " command="completeOrder">完成订单</el-dropdown-item>
                  <el-dropdown-item v-if="
                    (scope.row.ORMTB440CF01 == 0 ||
                      scope.row.ORMTB440CF01 == 1 ||
                      scope.row.ORMTB440CF01 == 2) &&
                    scope.row.isauditOrder == 0
                  " command="cancelOrder" id="取消订单" v-shiroHiden="solelist">取消订单</el-dropdown-item>
                  <el-dropdown-item v-if="
                    (scope.row.ORMTB440CF01 == 0 ||
                      scope.row.ORMTB440CF01 == 1 ||
                      scope.row.ORMTB440CF01 == 2) &&
                    scope.row.ORMTB440CA38 == 0
                  " command="freeze" id="冻结" v-shiroHiden="solelist">冻结</el-dropdown-item>
                  <el-dropdown-item v-if="
                    (scope.row.ORMTB440CF01 == 0 ||
                      scope.row.ORMTB440CF01 == 1 ||
                      scope.row.ORMTB440CF01 == 2 ||
                      scope.row.ORMTB440CF01 == -1) &&
                    scope.row.ORMTB440CA38 == 1
                  " command="unfreeze" id="解冻" v-shiroHiden="solelist">解冻</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.ORMTB440CF01 == 3" command="mistakeOrder">错单处理</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="dispatch-empty-state">
            <div class="dispatch-empty-title">{{ getDispatchEmptyTitle() }}</div>
            <div class="dispatch-empty-desc">{{ getDispatchEmptyDesc() }}</div>
            <el-button v-if="loadFailed" class="dispatch-empty-action" type="primary" plain @click="queryClick({ keepPage: true })">重新查询</el-button>
            <el-button v-else-if="activeFilterCount" class="dispatch-empty-action" plain @click="resetFilters">重置筛选</el-button>
          </div>
        </template>
      </el-table>
      <input ref="dispatchUploadInput" @change="inputFileChange" type="file" name="inputFile"
        style="display: none;" />
      <div class="pulbic_pagesize">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="limitMo"
          layout="total, sizes, prev, pager, next, jumper" :total="pagingPageMo">
        </el-pagination>
      </div>
    </div>
    <div class="public-dialog">
      <el-dialog title="派单详情" :visible.sync="oerderDetilsShow" width="62%" custom-class="dispatch-dialog"
        @close="detailsList = ''" :closeOnClickModal="false" append-to-body>
        <div class="dispatch-detail-layout">
          <!-- 左列：基础信息 -->
          <div class="dispatch-detail-left">
            <div class="dispatch-detail-col-title">基础信息</div>
            <div class="dispatch-summary-grid dispatch-summary-grid-single">
              <div class="dispatch-summary-item">
                <div class="dispatch-summary-label">流水号</div>
                <div class="dispatch-summary-value">{{ detailsList.ORMTB440CA00 || '--' }}</div>
              </div>
              <div class="dispatch-summary-item">
                <div class="dispatch-summary-label">企业名称</div>
                <div class="dispatch-summary-value">{{ detailsList.ORMTB440CA05 || '--' }}</div>
              </div>
              <div class="dispatch-summary-item">
                <div class="dispatch-summary-label">客户名称</div>
                <div class="dispatch-summary-value">{{ detailsList.ORMTB440CA03 || '--' }}</div>
              </div>
              <div class="dispatch-summary-item">
                <div class="dispatch-summary-label">车牌号</div>
                <div class="dispatch-summary-value">{{ detailsList.ORMTB440CA01 || '--' }}</div>
              </div>
              <div class="dispatch-summary-item">
                <div class="dispatch-summary-label">手机号</div>
                <div class="dispatch-summary-value">{{ detailsList.mobile || '--' }}</div>
              </div>
             <!-- <div class="dispatch-summary-item">
                <div class="dispatch-summary-label">派单方式</div>
                <div class="dispatch-summary-value">
                  {{
                    detailsList.ORMTB440CF00 == 'ZG'
                      ? '直供'
                      : detailsList.ORMTB440CF00 == 'LS'
                        ? '零售'
                        : detailsList.ORMTB440CF00 == 'QD'
                          ? '抢单'
                          : '--'
                  }}
                </div>
              </div> -->
              <div class="dispatch-summary-item">
                <div class="dispatch-summary-label">派单时间</div>
                <div class="dispatch-summary-value">{{ detailsList.ORMTB440CA19 || '--' }}</div>
              </div>
              <div class="dispatch-summary-item dispatch-summary-item-state" :class="detailsList.ORMTB440CC00 ? 'is-filled' : 'is-empty'">
                <div class="dispatch-summary-label">结算时间</div>
                <div class="dispatch-summary-value" :class="detailsList.ORMTB440CC00 ? 'dispatch-summary-value-filled' : 'dispatch-summary-value-empty'">{{ detailsList.ORMTB440CC00 || '暂无结算时间' }}</div>
              </div>
              <!-- <div class="dispatch-summary-item">
                <div class="dispatch-summary-label">回执时间</div>
                <div class="dispatch-summary-value">{{ detailsList.ORMTB440CE00 || '--' }}</div>
              </div> -->
              <div class="dispatch-summary-item dispatch-summary-item-state" :class="detailsList.ORMTB440CD01 ? 'is-filled' : 'is-empty'">
                <div class="dispatch-summary-label">原因</div>
                <el-tooltip placement="top" :content="detailsList.ORMTB440CD01 || '暂无原因'">
                  <div class="dispatch-summary-value dispatch-summary-value-multiline" :class="detailsList.ORMTB440CD01 ? 'dispatch-summary-value-filled' : 'dispatch-summary-value-empty'">
                    {{ detailsList.ORMTB440CD01 || '暂无原因' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="dispatch-summary-item dispatch-summary-item-state" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'" :class="detailsList.ORMTB440CN01 ? 'is-filled' : 'is-empty'">
                <div class="dispatch-summary-label">修改流水备注</div>
                <el-tooltip placement="top" :content="detailsList.ORMTB440CN01 || '暂无修改流水备注'">
                  <div class="dispatch-summary-value dispatch-summary-value-multiline" :class="detailsList.ORMTB440CN01 ? 'dispatch-summary-value-filled' : 'dispatch-summary-value-empty'">
                    {{ detailsList.ORMTB440CN01 || '暂无修改流水备注' }}
                  </div>
                </el-tooltip>
              </div>
              <div class="dispatch-summary-item dispatch-summary-item-state" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'" :class="detailsList.ORMTB440CN05 ? 'is-filled' : 'is-empty'">
                <div class="dispatch-summary-label">错单原因</div>
                <el-tooltip placement="top" :content="detailsList.ORMTB440CN05 || '暂无错单原因'">
                  <div class="dispatch-summary-value dispatch-summary-value-multiline" :class="detailsList.ORMTB440CN05 ? 'dispatch-summary-value-filled' : 'dispatch-summary-value-empty'">
                    {{ detailsList.ORMTB440CN05 || '暂无错单原因' }}
                  </div>
                </el-tooltip>
              </div>
            </div>
          </div>
          <!-- 右列：对比 + 图片 -->
          <div class="dispatch-detail-right">
            <div class="dispatch-detail-col-title">派单与结算对比</div>
            <div class="dispatch-compare-row">
              <div class="dispatch-compare-card">
                <div class="dispatch-compare-card-title">派单信息</div>
                <div class="dispatch-compare-list">
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">物料</span>
                    <span class="dispatch-compare-value">{{ detailsList.ORMTB440CA07 || '--' }}</span>
                  </div>
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">单价</span>
                    <span class="dispatch-compare-value">{{ formatMetricValue(detailsList.ORMTB440CA08) }}</span>
                  </div>
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">重量</span>
                    <span class="dispatch-compare-value">{{ formatMetricValue(detailsList.ORMTB440CA10) }}</span>
                  </div>
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">物料金额</span>
                    <span class="dispatch-compare-value">{{ formatMetricValue(detailsList.ORMTB440CA11) }}</span>
                  </div>
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">运费金额</span>
                    <span class="dispatch-compare-value">{{ formatMetricValue(detailsList.ORMTB440CA12) }}</span>
                  </div>
                </div>
              </div>
              <div class="dispatch-compare-card dispatch-compare-card-secondary">
                <div class="dispatch-compare-card-title">结算信息</div>
                <div class="dispatch-compare-list">
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">物料</span>
                    <span class="dispatch-compare-value">{{ detailsList.ORMTB440CC02 || '--' }}</span>
                  </div>
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">单价</span>
                    <span class="dispatch-compare-value">{{ formatMetricValue(detailsList.ORMTB440CC03) }}</span>
                  </div>
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">重量</span>
                    <span class="dispatch-compare-value">{{ formatMetricValue(detailsList.ORMTB440CC04) }}</span>
                  </div>
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">物料金额</span>
                    <span class="dispatch-compare-value">{{ formatMetricValue(detailsList.ORMTB440CC06) }}</span>
                  </div>
                  <div class="dispatch-compare-item">
                    <span class="dispatch-compare-label">运费金额</span>
                    <span class="dispatch-compare-value">{{ formatMetricValue(detailsList.jsORMTB440CA12) }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 磅单图片并排 -->
            <div class="dispatch-detail-images">
              <div v-if="
                detailsList.ORMTB440CA04 == '10000106' ||
                detailsList.ORMTB440CA04 == '10000107' ||
                detailsList.ORMTB440CA42 == '1'
              " class="dispatch-dialog-figure">
                <div class="DetailsWater-img-text">派单磅单</div>
                <el-image style="width: 72px; height: 72px" :src="detailsList.ORMTB440CL01"
                  :preview-src-list="DetailsWeightrcBDList">
                </el-image>
              </div>
              <div v-if="detailsList.ORMTB440CH05" class="dispatch-dialog-figure">
                <div class="DetailsWater-img-text">回执磅单</div>
                <el-image style="width: 72px; height: 72px" :src="detailsList.ORMTB440CH05"
                  :preview-src-list="DetailsWeightrcList">
                </el-image>
              </div>
            </div>
          </div>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button @click="oerderDetilsShow = false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="二维码详情" :visible.sync="ewmDetilsShow" width="35%" custom-class="dispatch-dialog"
        @close="ewmdetailsList = ''" :closeOnClickModal="false" append-to-body>
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">提货码信息</div>
          <div class="dispatch-dialog-intro-desc">用于快速核对车辆、订单和物料信息，支持直接预览二维码。</div>
        </div>
        <div class="DetailsWater-img dispatch-dialog-figure dispatch-dialog-figure-center">
          <div class="DetailsWater-img-text">二维码</div>
          <el-image style="width: 100px; height: 100px" :src="ewmdetailsList.ORMTB440CA22Img"
            :preview-src-list="ewmDetails">
            >
          </el-image>
        </div>

        <div class="DetailsWater-Dialog dispatch-detail-grid">
          <div class="DWD-li">
            <div class="DWD-li-title">车牌号</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB440CA01 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">订单编号</div>
            <div class="DWD-li-text">{{ ewmdetailsList.ORMTB430ID || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">下单时间</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB440CA19 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">企业</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB440CA24 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB440CA07 || '' }}
            </div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">吨数</div>
            <div class="DWD-li-text">
              {{ ewmdetailsList.ORMTB440CA10 || '' }}
            </div>
          </div>
        </div>
        <div class="dispatch-dialog-footer">
          <el-button @click="ewmDetilsShow = false">关闭</el-button>
        </div>
      </el-dialog>
    </div>
	
	<!-- 运输详情 -->
	<div class="public-dialog">
	  <el-dialog title="运输详情" :visible.sync="transportOerderDetilsShow" width="70%" custom-class="dispatch-dialog" @close="transportDetailsList = ''"
	    :closeOnClickModal="false" append-to-body>
		<div class="dispatch-dialog-intro">
				<div class="dispatch-dialog-intro-title">运输与结算信息</div>
				<div class="dispatch-dialog-intro-desc">按运输节点拆分展示运单、费用和结算结果，便于处理异常单据。</div>
			</div>
			<div class="transportxq dispatch-transport-layout">
			<div class="DetailsWater-Dialog dispatch-transport-panel">
				<div class="dispatch-dialog-block-title">
					物料
				</div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA00)">
			    <div class="DWD-li-title">流水号</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA00) }}</div>
			  </div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA05)">
			    <div class="DWD-li-title">装货地</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA05) }}</div>
			  </div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA33)">
			    <div class="DWD-li-title">卸货地</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA33) }}</div>
			  </div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA40)">
			    <div class="DWD-li-title">发单人</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA40) }}</div>
			  </div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA01)">
			    <div class="DWD-li-title">接单车号</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA01) }}</div>
			  </div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA16)">
			    <div class="DWD-li-title">接单时间</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA16) }}</div>
			  </div>
			  
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA17)">
			    <div class="DWD-li-title">出厂结算时间</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA17) }}</div>
			  </div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB460CA40)">
			    <div class="DWD-li-title">卸货时间</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB460CA40) }}</div>
			  </div>
			  
			  
			  
			  <div class="DWD-li" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'" :class="transportFieldState(transportDetailsList.ORMTB470CN01)">
			    <div class="DWD-li-title">修改流水备注</div>
			    <el-tooltip placement="top" :content="formatTransportValue(transportDetailsList.ORMTB470CN01)">
			      <div class="DWD-li-text">
			        {{ formatTransportValue(transportDetailsList.ORMTB470CN01) }}
			      </div>
			    </el-tooltip>
			  </div>
			  <div class="DWD-li" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'" :class="transportFieldState(transportDetailsList.ORMTB470CN18)">
			    <div class="DWD-li-title">错单原因</div>
			    <el-tooltip placement="top" :content="formatTransportValue(transportDetailsList.ORMTB470CN18)">
			      <div class="DWD-li-text">
			        {{ formatTransportValue(transportDetailsList.ORMTB470CN18) }}
			      </div>
			    </el-tooltip>
			  </div>
			</div>
			
			<div class="DetailsWater-Dialog dispatch-transport-panel">
				<div class="dispatch-dialog-block-title">
					运费
				</div>
				<div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA14)">
				  <div class="DWD-li-title">运费(每吨)</div>
				  <div class="DWD-li-text">
				    {{ formatTransportValue(transportDetailsList.ORMTB470CA14, '元') }}
				  </div>
				</div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.daohuoMoney)">
			    <div class="DWD-li-title">{{transportDetailsList.ORMTB460TP=='SL'?'直供':'含货配送'}}到货价</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.daohuoMoney, '元') }}</div>
			  </div>
			  <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA70)">
			    <div class="DWD-li-title">运费是否含税</div>
			    <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA70) }}</div>
			  </div>
			 <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA50)">
			   <div class="DWD-li-title">亏吨范围(吨)</div>
			   <div class="DWD-li-text">
			     {{ formatTransportValue(transportDetailsList.ORMTB470CA50, '吨') }}
			   </div>
			 </div>
			 <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA54)">
			   <div class="DWD-li-title">超时取消时间(小时)</div>
			   <div class="DWD-li-text">
			     {{ formatTransportValue(transportDetailsList.ORMTB470CA54, '小时') }}
			   </div>
			 </div>
			 <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB460CA38)">
			   <div class="DWD-li-title">运费卸货净重规则</div>
			   <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB460CA38) }}</div>
			 </div>
			 <div class="DWD-li" :class="transportFieldState(getFirstFieldContent(transportDetailsList.ORMTB470CA39, transportDetailsList.ORMTB460CA39))">
			   <div class="DWD-li-title">运费结算甩零规则</div>
			   <div class="DWD-li-text">{{ formatTransportValue(getFirstFieldContent(transportDetailsList.ORMTB470CA39, transportDetailsList.ORMTB460CA39)) }}</div>
			 </div>
			 
			 <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA48)">
			   <div class="DWD-li-title">票号</div>
			   <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA48) }}</div>
			 </div>
			 
			 <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA29)">
			   <div class="DWD-li-title">原因</div>
			   <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA29) }}</div>
			 </div>
			 
			 <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CA44)">
			   <div class="DWD-li-title">磅单审核拒绝原因</div>
			   <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CA44) }}</div>
			 </div>
			
			 <div class="DWD-li" :class="transportFieldState(transportDetailsList.ORMTB470CC02)">
			   <div class="DWD-li-title">完成结算时间</div>
			   <div class="DWD-li-text">{{ formatTransportValue(transportDetailsList.ORMTB470CC02) }}</div>
			 </div>
			 
			</div>
			
			
		</div>
	  
		<div class="dispatch-dialog-block-title dispatch-dialog-block-title-spaced">结算对比</div>
		<div class="dispatch-compare-cards">
		  <div class="dispatch-compare-card-new">
		    <div class="dispatch-compare-card-header">接单</div>
		    <div class="dispatch-compare-card-body">
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">物料</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA07 || '--' }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">单价</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA08 || '--' }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">重量</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CB02 || 0 }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">物料金额</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA09 || 0 }}</span>
		      </div>
		    </div>
		  </div>
		  <div class="dispatch-compare-card-new">
		    <div class="dispatch-compare-card-header">出厂结算</div>
		    <div class="dispatch-compare-card-body">
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">物料</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA19 || '--' }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">单价</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA20 || '--' }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">重量</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA21 || 0 }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">物料金额</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA23 || 0 }}</span>
		      </div>
		    </div>
		  </div>
		  <div class="dispatch-compare-card-new dispatch-compare-card-new--final">
		    <div class="dispatch-compare-card-header">卸货结算</div>
		    <div class="dispatch-compare-card-body">
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">物料</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA19 || '--' }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">单价</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA20 || '--' }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">重量</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CC08 || 0 }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">物料金额</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA23 || 0 }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">扣除运费</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CC06 || 0 }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">结算运费</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CC12 || 0 }}</span>
		      </div>
		      <div class="dispatch-compare-card-row">
		        <span class="dispatch-compare-card-label">额外费用</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA72 || 0 }}</span>
		      </div>
		      <div class="dispatch-compare-card-row" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
		        <span class="dispatch-compare-card-label">管理费</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA60 || 0 }}</span>
		      </div>
		      <div class="dispatch-compare-card-row" v-if="uobj.pertb005.pertb005cb00 == 'CUS-1'">
		        <span class="dispatch-compare-card-label">运费补贴</span>
		        <span class="dispatch-compare-card-value">{{ transportDetailsList.ORMTB470CA71 || 0 }}</span>
		      </div>
		    </div>
		  </div>
		</div>
		
		
		<div
		  v-if="
		    transportDetailsList.ORMTB470CA67 &&
		      (transportDetailsList.ORMTB470CA04 == '10000106' ||
		        transportDetailsList.ORMTB470CA04 == '10000107' ||
		        transportDetailsList.ORMTB440CA42 == '1')
		  "
		  class="DetailsWater-img dispatch-dialog-figure"
		>
		
	      <div class="DetailsWater-img-text">出厂磅单</div>
	      <el-image style="width: 80px; height: 80px" :src="transportDetailsList.ORMTB470CA67"
	        :preview-src-list="DetailsWeightrcBDList">
	      </el-image>
	    </div>
	    <div v-if="transportDetailsList.ORMTB470CA35" class="DetailsWater-img dispatch-dialog-figure">
	      <div class="DetailsWater-img-text">卸货磅单</div>
	      <el-image style="width: 80px; height: 80px" :src="transportDetailsList.ORMTB470CA35"
	        :preview-src-list="DetailsWeightrcList">
	      </el-image>
	    </div>
	    <div class="dispatch-dialog-footer">
	      <el-button @click="transportOerderDetilsShow = false">关闭</el-button>
	    </div>
	  </el-dialog>
	</div>
	
    <div class="public-dialog">
      <el-dialog title="订单审核" :visible.sync="orderAuditShow" @close="detailsList = ''" width="30%"
        custom-class="dispatch-dialog" :closeOnClickModal="false" append-to-body>
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">审核前确认</div>
          <div class="dispatch-dialog-intro-desc">请先核对订单核心信息，再执行通过或拒绝操作。</div>
        </div>
        <div class="DetailsWater-Dialog dispatch-detail-grid">
          <div class="DWD-li">
            <div class="DWD-li-title">企业名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">客户名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA03 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA07 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA10 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">车牌号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA01 || '' }}</div>
          </div>
        </div>
        <div class="dispatch-dialog-footer dispatch-dialog-footer-split">
          <el-button @click="orderAuditShow = false">取消</el-button>
          <div class="dispatch-dialog-footer-actions">
            <el-button type="primary" :loading="auditSubmitting" :disabled="auditSubmitting"
              @click="handleOrderAuditAction(1)">通过</el-button>
            <el-button type="danger" :loading="auditSubmitting" :disabled="auditSubmitting"
              @click="handleOrderAuditAction(2)">拒绝</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog title="派单审核" :visible.sync="isorderAuditShow" @close="; (detailsList = ''), (isorderAuditText = '')"
        width="30%" custom-class="dispatch-dialog" :closeOnClickModal="false" append-to-body>
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">审核前确认</div>
          <div class="dispatch-dialog-intro-desc">金额和运费信息会直接影响后续结算，拒绝时建议补充审核说明。</div>
        </div>
        <div class="DetailsWater-Dialog dispatch-detail-grid">
          <div class="DWD-li">
            <div class="DWD-li-title">企业名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA05 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">客户名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA03 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">物料名称</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA07 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">重量</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA10 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">车牌号</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA01 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">派单物料金额</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA11 || '' }}</div>
          </div>
          <div class="DWD-li">
            <div class="DWD-li-title">派单运费</div>
            <div class="DWD-li-text">{{ detailsList.ORMTB440CA12 || '' }}</div>
          </div>
          <div class="DWD-li dispatch-dialog-input-row">
            <div class="DWD-li-title">审核说明</div>
            <div class="DWD-li-text">
              <el-input ref="dispatchAuditReason" v-model="isorderAuditText" maxlength="20" show-word-limit
                placeholder="请输入审核说明（选填）" />
            </div>
          </div>
        </div>
        <div class="dispatch-dialog-footer dispatch-dialog-footer-split">
          <el-button @click="isorderAuditShow = false">取消</el-button>
          <div class="dispatch-dialog-footer-actions">
            <el-button type="primary" :loading="dispatchAuditSubmitting" :disabled="dispatchAuditSubmitting"
              @click="handleDispatchAuditAction(1)">通过</el-button>
            <el-button type="danger" :loading="dispatchAuditSubmitting" :disabled="dispatchAuditSubmitting"
              @click="handleDispatchAuditAction(2)">拒绝</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="public-dialog">
      <el-dialog title="回执登记" :visible.sync="returnReceiptShow" @close="detailsList = ''" width="30%"
        custom-class="dispatch-dialog" :closeOnClickModal="false" append-to-body>
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">补充回执信息</div>
          <div class="dispatch-dialog-intro-desc">请录入回执重量与回执运费单价，必填项会直接参与后续结算。</div>
        </div>
        <div class="CustomerfillingDig-tab dispatch-form-grid">
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">车牌号：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              {{ detailsList.ORMTB440CA01 || '' }}
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">回执物料：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              {{ detailsList.ORMTB440CA07 || '' }}
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li" :class="{ 'dispatch-form-row-error': receiptWeightError }">
            <div class="CustomerfillingDig-tab-li-text">回执重量：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input ref="topWeight" type="text" v-model="detailsList.ORMTB440CE02" maxlength="10"
                @input="topWeightInput" @change="topWeightChange" />
            </div>
            <div class="CustomerfillingDig-tab-li-b">*必填*</div>
          </div>
          <div class="CustomerfillingDig-tab-li" :class="{ 'dispatch-form-row-error': receiptMoneyError }">
            <div class="CustomerfillingDig-tab-li-text">回执运费单价：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input ref="topMoney" type="text" v-model="detailsList.ORMTB440CA21" maxlength="10" @input="topMoneyInput"
                @change="topMoneyChange" />
            </div>
            <div class="CustomerfillingDig-tab-li-b">*必填*</div>
          </div>
        </div>
        <div class="dispatch-form-feedback">
          <span>{{ receiptWeightError || '回执重量已填写后会参与运费计算' }}</span>
          <span>{{ receiptMoneyError || `预计回执运费：${receiptPreviewAmountText}` }}</span>
        </div>
        <div class="DetailsWater-img dispatch-dialog-figure">
          <div class="DetailsWater-img-text">回执记录</div>
          <el-image style="width: 80px; height: 80px" :src="DetailsWaterurl" :preview-src-list="DetailsWatersrcList">
          </el-image>
        </div>
        <div class="dispatch-dialog-footer dispatch-dialog-footer-split">
          <el-button @click="returnReceiptShow = false">取消</el-button>
          <div class="dispatch-dialog-footer-actions">
            <el-button type="primary" :loading="receiptSubmitting" :disabled="receiptSubmitting"
              @click="returnReceiptserve">确定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>

    <div class="public-dialog">
      <el-dialog title="完成订单" :visible.sync="inputWeightShow" @close="inputWeightClose" width="30%"
        custom-class="dispatch-dialog" :closeOnClickModal="false" append-to-body>
        <div class="dispatch-dialog-intro">
          <div class="dispatch-dialog-intro-title">录入结算信息</div>
          <div class="dispatch-dialog-intro-desc">支持调整结算物料、重量和金额，净重会根据毛重与皮重自动联动。</div>
        </div>
        <div class="dispatch-complete-plate">
          <span>车牌号：</span>
          <strong>{{ detailsList.ORMTB440CA01 || '--' }}</strong>
        </div>
        <div class="CustomerfillingDig-tab dispatch-form-grid">
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">派单物料：</div>
            <div class="CustomerfillingDig-tab-li-ipt dispatch-complete-material-field">
              <!-- <input type="text" v-model="detailsList.ORMTB440CA07" disabled> -->
              <el-select ref="completeMaterial" class="dispatch-complete-material-select" v-model="materialValue" placeholder="请选择" @change="materialChange">
                <el-option v-for="item in materialList" :key="item.value" :label="item.lable" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="CustomerfillingDig-tab-li-b dispatch-required-text">*必填</div>
          </div>
          <div class="CustomerfillingDig-tab-li" :class="{ 'dispatch-form-row-error': completePriceError }">
            <div class="CustomerfillingDig-tab-li-text">单价：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input ref="completePrice" type="number" v-model="weightOpt.price" maxlength="10"
                @input="inputWeightFormat($event, 'price')" />
            </div>
            <div class="CustomerfillingDig-tab-li-b dispatch-required-text">*必填</div>
          </div>
          <div class="CustomerfillingDig-tab-li" :class="{ 'dispatch-form-row-error': completeGrossError }">
            <div class="CustomerfillingDig-tab-li-text">毛重：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input ref="completeGross" type="number" v-model="weightOpt.tare" maxlength="10" @input="inputWeightFormat($event, 'tare')" />
            </div>
            <div class="CustomerfillingDig-tab-li-b dispatch-required-text">*必填</div>
          </div>
          <div class="CustomerfillingDig-tab-li" :class="{ 'dispatch-form-row-error': completeTareError || completeNetWeightError }">
            <div class="CustomerfillingDig-tab-li-text">皮重：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input ref="completeTare" type="number" v-model="weightOpt.gross" maxlength="10"
                @input="inputWeightFormat($event, 'gross')" />
            </div>
            <div class="CustomerfillingDig-tab-li-b dispatch-required-text">*必填</div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">净重：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input type="text" v-model="detailsList.ORMTB440CC04" maxlength="10" disabled />
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
          <div class="CustomerfillingDig-tab-li">
            <div class="CustomerfillingDig-tab-li-text">结算金额：</div>
            <div class="CustomerfillingDig-tab-li-ipt">
              <input type="text" v-model="detailsList.ORMTB440CC06" maxlength="100" :disabled="distf" />
            </div>
            <div class="CustomerfillingDig-tab-li-b"></div>
          </div>
        </div>
        <div class="dispatch-form-feedback dispatch-form-feedback-highlight">
          <span :class="['dispatch-form-feedback-emphasis', { 'is-error': completeNetWeightError }]">
            {{ completeNetWeightError || `当前净重：${completeNetWeightText}` }}
          </span>
          <span :class="['dispatch-form-feedback-emphasis', 'is-primary', `is-${completeSettlementStatus}`]">
            {{ completeSettlementHint }}
          </span>
        </div>
        <div class="Customer-upload-bd" v-if="
            detailsList.ORMTB440CA04 == '10000106' ||
            detailsList.ORMTB440CA04 == '10000107' ||
            detailsList.ORMTB440CA42 == '1'
          ">
            <el-upload action="" list-type="picture" :class="{ disabled: uploadDisabled }" :auto-upload="false"
              :limit="1" ref="upload" :on-change="handleChange"
              :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :file-list="fileList">
              <el-button size="small" type="primary">点击上传磅单</el-button>
            </el-upload>
            <!-- 预览图片 -->
            <el-dialog :visible.sync="dialogVisibleimg" append-to-body custom-class="sales-dispatch-management-dialog">
              <img width="80%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </div>
        <div class="dispatch-dialog-footer dispatch-dialog-footer-split">
          <el-button @click="inputWeightShow = false">取消</el-button>
          <div class="dispatch-dialog-footer-actions">
            <el-button type="primary" :loading="completeSubmitting" :disabled="completeSubmitting"
              @click="inputWeightConfirm">确定</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import timerUtils from '@/utils/timerUtils';
import qs from 'qs'
import debounce from '../../api/debounce'
import customerSearchMixin from '@/mixins/customerSearchMixin'
import enterpriseSearchMixin from '@/mixins/enterpriseSearchMixin'

export default {
  mixins: [customerSearchMixin, enterpriseSearchMixin],
  data() {
    return {
      weightOpt: {
        tare: '',
        gross: '',
        price: '',
      },
      dialogVisibleimg: false,
      dialogImageUrl: '',
      formdata: new FormData(),
      fileList: [],
      addimg: [],
      removeimg: [],
      ruleForm: {
        csAvatar: '',
        fileId: ''
      },
      filUrl: '/system/uploadBD',
      loadingBut: false,
      confirmTxt: 0,
      auditSubmitting: false,
      dispatchAuditSubmitting: false,
      receiptSubmitting: false,
      completeSubmitting: false,
      settlementAmountLoading: false,
      receiptSubmitAttempted: false,
      completeSubmitAttempted: false,
      initialLoading: false,
      tableLoading: false,
      statsLoading: false,
      hasLoadedOnce: false,
      loadFailed: false,
      secondaryFilterVisible: false,
      refreshError: false,
      isAutoRefreshing: false,
      lastRefreshTime: '',
      lastRefreshSource: '',
      inputWeightShow: false, // 输入磅单信息弹窗
      isorderAuditText: '',
      oerderDetilsShow: false,
      cdclDetilsShow: false,
      ewmDetilsShow: false,
      orderAuditShow: false,
      isorderAuditShow: false,
      returnReceiptShow: false,
      uobj: this.$store.state.uobj, //登陆缓存--用户信息
      date: [], //日期
      startTime: '',
      endTime: '',
      dateNowDayActive: false,
      dateYesterdayActive: false,
      dateNowMonthActive: false,
      dateLastMonthActive: false,
      twolevelUserLogin: true,
      timeIndex: 0, //判断第几次切换当月时间
      sameMonthTime: '', //目前月份
      currentMonthTime: '', //目前月份--上月+1
      tableData: [],
      ORMTB440CA00: '',
      materialOptions: [],
      materialTypeValue: '',
      carNum: '',
      materielMo: '',
      materielOptions: [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ],
      // 代下单
      orOptions: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      // 离线订单
      orlxOrdeOptions: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      //修改
      orXgOrdeOptions: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      //错单
      orCdOrdeOptions: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '1',
          label: '是',
        },
      ],
      lxorde: '',
      xgorde: '',
      cdorde: '',
      // 状态
      dataStatusOperation: [
        {
          value: '',
          label: '全部',
        },
        {
          value: '0',
          label: '待接单',
        },
        // {
        // 	value: '1',
        // 	label: '待提货',
        // },
        {
          value: '2',
          label: '提货中',
        },
        {
          value: '3',
          label: '完成',
        },
        // {
        // 	value: '4',
        // 	label: '回执',
        // },
        // {
        // 	value: '5',
        // 	label: '确认回执',
        // },
        {
          value: '-1',
          label: '取消',
        },
        {
          value: '9',
          label: '申请取消',
        },
        {
          value: '6',
          label: '申请完成',
        },
      ],
      jscc: 0,
      jsje: 0,
      jszl: 0,
      pdcc: 0,
      pdje: 0,
      pdzl: 0,
      // 查询
      customerMo: '', //客户--查询
      SETTB122CA07: '', //数据状态
      ORMTB440CA29: '', //代下单状态
      billOperationAdd: false,
      enterpriseTwoOptionList: [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ], //二级企业下拉框--新增
      enterpriseTwo: '', //二级企业
      carNumber: '', //车牌号
      pageMo: 1, //默认列表页码
      limitMo: 10, //每页的条数
      pagingPageMo: 0, //分页--数据列表共有的条数
      currentPage: 1, //设置当前页默认为1
      // 列设置
      checkAll: false,
      checkedCities: [],
      cities: [
        '结算时间',
        '结算金额',
        '流水号',
        '车牌号',
        '订单物料',
        '完成物料',
        '派单单价',
        '结算单价',
        '重量',
      ],
      isIndeterminate: false,
      // 详情
      billOperationDetails: false,
      detailsList: '', //详情列表
      ewmdetailsList: '', //详情列表
      tableHeadList: [],
      tableHeadListInit: [
        {
          prop: 'ORMTB440CC00',
          label: '结算时间',
          width: 110,
        },
        {
          prop: 'ORMTB440CC06',
          label: '结算金额',
          width: 110,
        },
        {
          prop: 'ORMTB440CA00',
          label: '流水号',
          width: 130,
        },
        {
          prop: 'ORMTB440CA01',
          label: '车牌号',
          width: 100,
        },
        {
          prop: 'ORMTB440CA07',
          label: '订单物料',
          width: 100,
        },
        {
          prop: 'ORMTB440CC02',
          label: '完成物料',
          width: 100,
        },
        {
          prop: 'ORMTB440CA08',
          label: '派单单价',
          width: 100,
        },
        {
          prop: 'ORMTB440CC03',
          label: '结算单价',
          width: 100,
        },
        {
          prop: 'ORMTB440CA10',
          label: '重量',
          width: 100,
        },
      ],
      isRefresh: true,
      isRefreshSetInterval: '',
      // quanpDisabled: false,
      // 历史缓存
      currentUrl: this.$route.path,
      historyInfo: '',
      // 时间限制
      // 限制开始日期不能超过当前日期
      startDateDisabled: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
      solelist: [],
      DetailsWaterurl: '',
      DetailsWatersrcList: [],
      DetailsWeightrcList: [],
      DetailsWeightrcBDList: [],
      ewmDetails: [],
      materialList: [],
      materialValue: '',
      listTick: null, // 列表刷新定时器
      timeType: '1',
      distf: true,
      dcmoreID: '',
      dcmore: '',

      // 错单处理
      sfzz: "1",
      description: '',
      cdlxValue: '',
      cdlxList: [],
      areaOpen: 0,
      areaOpenOptions: [
        {
          value: 0,
          label: '是'
        },
        {
          value: 1,
          label: '否'
        }
      ],
	  orderCategory:'',//订单类别
	  orderCategoryOpenOptions: [
	  		  {
	  		    value: '',
	  		    label: '全部'
	  		  },
	    {
	      value: 1,
	      label: '自提'
	    },
	    {
	      value: 2,
	      label: '运输'
	    }
	  ],
	  orderSource:'',//订单出处
	  orderSourceOpenOptions: [
		  {
		    value: '',
		    label: '全部'
		  },
	    {
	      value: 0,
	      label: '客户'
	    },
	    {
	      value: 1,
	      label: '平台'
	    }
	  ],
	
	  
	  
	  // 运输详情
	  transportDetailsList:'',
	  transportOerderDetilsShow:false,
    timer: null
    }
  },
  watch: {
    weightOpt: {
      handler(val) {
        if (
          (val.tare || val.tare === 0) &&
          (val.gross || val.gross === 0) &&
          (val.price || val.price === 0)
        ) {
          let tare = parseFloat(val.tare)
          let gross = parseFloat(val.gross)
          let netWeight = tare - gross
          this.detailsList.ORMTB440CC04 = Number.isFinite(netWeight) ? netWeight.toFixed(2) : ''
          if (Number.isFinite(netWeight) && netWeight >= 0 && this.detailsList.ORMTB440CC04) {
            this._debouncedGetSettlementAmount()
          } else {
            this.detailsList.ORMTB440CC06 = ''
            this.settlementAmountLoading = false
          }
        } else {
          this.detailsList.ORMTB440CC04 = ''
          this.detailsList.ORMTB440CC06 = ''
          this.settlementAmountLoading = false
        }
      },
      deep: true,
    },
  },
  created() {
    this._debouncedGetSettlementAmount = () => {
      debounce(() => this.getSettlementAmount(), 500)
    }
    var list = ''
    list = this.$store.state.solelist
    // console.log(list)
    // 赋值，缓存销毁
    this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
    sessionStorage.removeItem(this.currentUrl)
    if (this.historyInfo != null && this.historyInfo != '') {
      this.init()
    }
    // console.log(this.historyInfo)
    // else {
    // 	this.getNowDay();
    // }
    var path = this.$route.path
    if (path === '/SalesDispatchManagement') {
      path = '/Home' + path
    }
    this.solelist = this.$baseAPI.querSoleList(list, path) //获取权限列表

    // console.log(this.uobj)
  },
  mounted() {
    if (this.historyInfo == null && this.$route.query.mark == null) {
      this.getNowDay()
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.dateNowDayActive = true
    }

    this.optionLists()
    this.enterprise0ptions()
    // this.listTick = setInterval(() => {
    //   this.queryClick()
    // }, 1000 * 60)
    this.startTimer();
    // console.log(this.$store.state.uobj)
  },
  activated() {
    this.startTimer();
  },
  
  deactivated() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  // 存储数据
  beforeDestroy() {
    // clearInterval(this.listTick)
    // this.listTick = null
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.startTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.date[0]))
    this.endTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.date[1]))
    var obj = {
      startTime: this.startTime,
      endTime: this.endTime, //开始时间
      ORMTB440CA02: this.ORMTB440CA02, //客户id
      ORMTB400CA03: this.ORMTB400CA03, //客户名称
      ORMTB440CA04: this.ORMTB440CA04, //客户名称
      ORMTB440CA06: this.ORMTB440CA06, //二级企业id
      ORMTB440CF01: this.ORMTB440CF01, //二级企业名称
      ORMTB440CA00: this.ORMTB440CA00, //数据状态--转换
      ORMTB440CA01: this.ORMTB440CA01, //数据状态--名字
      currentPage: this.currentPage, //当前页数
      pageMo: this.pageMo, //页码
      limitMo: this.limitMo, //每页条数
      dateNowDayActive: this.dateNowDayActive,
      dateYesterdayActive: this.dateYesterdayActive,
      dateNowMonthActive: this.dateNowMonthActive,
      dateLastMonthActive: this.dateLastMonthActive,
      ORMTB440CA00: this.ORMTB440CA00,
    }
  },
  computed: {
    uploadDisabled: function () {
      // console.log(this.ruleForm.csAvatar)
      return this.ruleForm.csAvatar != ''
    },
    activeFilterCount() {
      const filters = [
        this.enterpriseTwo,
        this.customerMo,
        this.materielMo,
        this.SETTB122CA07,
        this.carNumber,
        this.ORMTB440CA00,
        this.timeType !== '1' ? this.timeType : '',
        this.ORMTB440CA29,
        this.lxorde,
        this.xgorde,
        this.cdorde,
        this.orderCategory,
        this.orderSource,
      ]
      return filters.filter(item => item !== '' && item !== null && item !== undefined).length
    },
    refreshStatusText() {
      if (this.initialLoading && !this.hasLoadedOnce) {
        return '正在加载...'
      }
      if (this.isAutoRefreshing) {
        return '正在自动刷新...'
      }
      if (this.tableLoading || this.statsLoading) {
        return '正在刷新...'
      }
      if (this.refreshError && this.hasLoadedOnce) {
        return this.lastRefreshTime ? `刷新失败，展示上次结果 · 最近更新 ${this.lastRefreshTime}` : '刷新失败，展示上次结果'
      }
      if (this.loadFailed) {
        return '加载失败，请重试'
      }
      if (this.lastRefreshTime) {
        return `最近更新 ${this.lastRefreshTime}`
      }
      return '等待查询'
    },
    isAnyDispatchDialogOpen() {
      return this.oerderDetilsShow ||
        this.cdclDetilsShow ||
        this.ewmDetilsShow ||
        this.transportOerderDetilsShow ||
        this.orderAuditShow ||
        this.isorderAuditShow ||
        this.returnReceiptShow ||
        this.inputWeightShow ||
        this.dialogVisibleimg
    },
    receiptWeightError() {
      if (!this.receiptSubmitAttempted) return ''
      return this.detailsList && this.detailsList.ORMTB440CE02 ? '' : '请输入回执重量'
    },
    receiptMoneyError() {
      if (!this.receiptSubmitAttempted) return ''
      return this.detailsList && this.detailsList.ORMTB440CA21 ? '' : '请输入回执运费单价'
    },
    receiptPreviewAmountText() {
      const weight = parseFloat(this.detailsList && this.detailsList.ORMTB440CE02)
      const price = parseFloat(this.detailsList && this.detailsList.ORMTB440CA21)
      if (!Number.isFinite(weight) || !Number.isFinite(price)) {
        return '--'
      }
      return `${(weight * price).toFixed(2)} 元`
    },
    completeNetWeightValue() {
      const value = parseFloat(this.detailsList && this.detailsList.ORMTB440CC04)
      return Number.isFinite(value) ? value : null
    },
    completeNetWeightText() {
      if (this.completeNetWeightValue === null) {
        return '--'
      }
      return `${this.completeNetWeightValue.toFixed(2)} 吨`
    },
    completeSettlementAmountText() {
      const value = this.detailsList && this.detailsList.ORMTB440CC06
      if (value === '' || value === null || value === undefined) {
        return '--'
      }
      const numberValue = parseFloat(value)
      if (!Number.isFinite(numberValue)) {
        return `${value}`
      }
      return `${numberValue.toFixed(2)} 元`
    },
    completeSettlementStatus() {
      if (this.settlementAmountLoading) return 'loading'
      if (this.completeNetWeightValue !== null && this.completeNetWeightValue < 0) return 'error'
      if (!this.materialValue) return 'pending'
      if (this.weightOpt.price === '' || this.weightOpt.price === null || this.weightOpt.price === undefined) return 'pending'
      if (!(this.weightOpt.tare || this.weightOpt.tare === 0)) return 'pending'
      if (!(this.weightOpt.gross || this.weightOpt.gross === 0)) return 'pending'
      return 'ready'
    },
    completeSettlementHint() {
      if (this.completeSettlementStatus === 'loading') return '正在计算结算金额...'
      if (this.completeSettlementStatus === 'error') return '毛重必须大于或等于皮重'
      if (!this.materialValue) return '待选择物料后计算金额'
      if (this.weightOpt.price === '' || this.weightOpt.price === null || this.weightOpt.price === undefined) return '待输入单价后计算金额'
      if (!(this.weightOpt.tare || this.weightOpt.tare === 0)) return '待输入毛重后计算金额'
      if (!(this.weightOpt.gross || this.weightOpt.gross === 0)) return '待输入皮重后计算金额'
      return `当前结算金额：${this.completeSettlementAmountText}`
    },
    completePriceError() {
      if (!this.completeSubmitAttempted) return ''
      return this.weightOpt.price || this.weightOpt.price === 0 ? '' : '请输入单价'
    },
    completeGrossError() {
      if (!this.completeSubmitAttempted) return ''
      return this.weightOpt.tare ? '' : '请输入毛重'
    },
    completeTareError() {
      if (!this.completeSubmitAttempted) return ''
      return this.weightOpt.gross ? '' : '请输入皮重'
    },
    completeNetWeightError() {
      if (!this.completeSubmitAttempted) return ''
      if (this.completeNetWeightValue === null) return ''
      return this.completeNetWeightValue < 0 ? '毛重必须大于或等于皮重' : ''
    },
  },
  methods: {
    focusField(refName) {
      this.$nextTick(() => {
        const ref = this.$refs[refName]
        if (!ref) return
        if (typeof ref.focus === 'function') {
          ref.focus()
          return
        }
        if (ref.$el) {
          const input = ref.$el.querySelector('input')
          if (input) {
            input.focus()
          }
        }
      })
    },
    applyCurrentDateRange() {
      this.startTime = this.date && this.date.length ? this.date[0] : ''
      this.endTime = this.date && this.date.length ? this.date[1] : ''
    },
    formatMetricValue(value) {
      return value === '' || value === null || value === undefined ? '--' : value
    },
    hasFieldContent(value) {
      return value !== '' && value !== null && value !== undefined
    },
    formatTransportValue(value, unit = '') {
      return this.hasFieldContent(value) ? `${value}${unit}` : '暂无'
    },
    getFirstFieldContent() {
      for (var i = 0; i < arguments.length; i++) {
        if (this.hasFieldContent(arguments[i])) {
          return arguments[i]
        }
      }
      return ''
    },
    transportFieldState(value) {
      return this.hasFieldContent(value) ? 'is-filled' : 'is-empty'
    },
    formatRefreshTime(date) {
      return this.dateFtt('hh:mm:ss', date)
    },
    getDispatchEmptyTitle() {
      if (this.loadFailed && !this.hasLoadedOnce) {
        return '派单数据加载失败'
      }
      return '暂无派单数据'
    },
    getDispatchEmptyDesc() {
      if (this.loadFailed && !this.hasLoadedOnce) {
        return '请检查网络后重试，或稍后重新查询。'
      }
      if (this.activeFilterCount) {
        return '当前筛选条件下暂无结果，可调整条件或重置筛选后重试。'
      }
      return '请先选择筛选条件或时间范围后再查询。'
    },
    resetFilters() {
      this.customerMo = ''
      this.enterpriseTwo = ''
      this.materielMo = ''
      this.SETTB122CA07 = ''
      this.carNumber = ''
      this.ORMTB440CA00 = ''
      this.timeType = '1'
      this.ORMTB440CA29 = ''
      this.lxorde = ''
      this.xgorde = ''
      this.cdorde = ''
      this.orderCategory = ''
      this.orderSource = ''
      this.pageMo = 1
      this.currentPage = 1
      this.getNowDay()
      this.applyCurrentDateRange()
      this.queryClick()
    },
    startTimer() {
      if (this.timer) return // 防止重复创建

      this.timer = setInterval(() => {
        if (this.isAnyDispatchDialogOpen) return
        this.queryClick({ source: 'auto', keepPage: true, silent: true })
      }, 1000 * 60)
    },
    // 值改变 重新获取结算金额
    async materialChange(val) {
      if (val == this.detailsList.ORMTB440CC01) {
        this.weightOpt.price = this.detailsList.ORMTB440CC03
      } else {
        await this.queryMaterialPrice(val)
      }
      this.getSettlementAmount()
    },
    // 根据物料id 查询单价
    async queryMaterialPrice(ORMTB440CC01) {
      let url = '/orm/ormtb440/unitPriceAuto'
      let params = {
        ORMTB440CC01, // 结算物料id
        ORMTB440ID: this.detailsList.ORMTB440ID,
        ORMTB440CA02: this.detailsList.ORMTB440CA02, //客户id
        ORMTB440CA04: this.detailsList.ORMTB440CA04, // 二级企业ID
        ORMTB440ID: this.detailsList.ORMTB440ID, // 二级企业ID
      }
      params = qs.stringify(params)
      let header = {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
      let res = await this.axios.post(url, params, {
        header,
      })
      if (res.data.code === 200) {
        this.weightOpt.price = res.data.data
      }
    },

    // cdlxChangeFun(val) {

    // },

    // 文件状态改变时添加文件、上传成功和上传失败时都会被调用
    handleChange(file, fileList) {
      const isJPG =
        file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 、png 格式!')
        fileList.splice(-1, 1) //移除错误文件
        return false
      }
      if (!isLt5M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
        fileList.splice(-1, 1)
        return false
      }

      this.addimg = fileList[0].raw
      // this.ruleForm.csAvatar = this.addimg;
      // console.log(file)
      // console.log(fileList)
      this.fileList = []
      let data = new FormData()
      data.append('file', this.addimg)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/system/uploadBD'
      this.axios
        .post(url, data, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            // console.log(res)
            this.ruleForm.csAvatar = res.data.data.bdurl
            this.ruleForm.fileId = res.data.data.fileId
            this.fileList = fileList
            // console.log(this.fileList)
            this.$message({
              message: res.data.data.message,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },

    stuUpdjd() {
      // this.handleSpeak('厂家调价了') // 传入需要播放的文字

      if (this.enterpriseTwo == '') {
        this.$message({
          message: '请选择厂家',
          type: 'error',
        })
        return
      }

      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb440/comOrders'
      var postData = {
        ORMTB440CA04: this.enterpriseTwo,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
            this.queryClick()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })

      // if(this.SETTB122CA07 ==''){
      // 	this.$message({
      // 		message: '请选择订单状态',
      // 		type: 'error'
      // 	});
      // 	return
      // }
    },
    // 语音播报的函数
    // handleSpeak(text) {
    //   msg.text = text // 内容
    //   msg.lang = 'zh-CN' // 使用的语言:中文
    //   msg.volume = 1 // 声音音量：1
    //   msg.rate = 1 // 语速：1
    //   msg.pitch = 1 // 音高：1
    //   synth.speak(msg) // 播放
    // },
    // // 语音停止
    // handleStop(e) {
    //   msg.text = e
    //   msg.lang = 'zh-CN'
    //   synth.cancel(msg) // 取消该次语音播放
    // },
   
    // 删除活动展示照片
    handleRemove(file, fileList) {
      // console.log(fileList)
      var index1 = this.ruleForm.csAvatar.lastIndexOf('2022', '2023')
      var imgdel = this.ruleForm.csAvatar.substring(index1)
      // console.log(imgdel)
      let loading = this.$loading({
        lock: true,
        text: '请求中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb440/deleteFile'
      var postData = {
        fileName: imgdel,
      }
      this.axios
        .post(url, postData)
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            // console.log(res)
            this.ruleForm.csAvatar = ''
            this.ruleForm.fileId = ''
            this.formdata = new FormData()
            this.$message({
              message: res.data.message,
              type: 'success',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    // 活动展示照片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisibleimg = true
    },
    // 渲染编辑获取id
    apply() {
      this.fileList = [
        {
          url: '',
        },
      ] //这里是踩坑的点，必须写
      this.fileList[0].url = res.data.csAvatar //这里是调用接口获取到的值 res.data.csAvatar，赋值就可以回显了
      //this.fileList[0].url 做的是单张图片回显，多张图片回显可以去掉[0]
    },

    // 获取派单物料列表
    getSelectMaterial() {
      var postData = {
        SETTB99ID: this.detailsList.ORMTB440CA04,
      }
      this.materialList = []
      postData = qs.stringify(postData)
      var url = '/set/settb109/select_material'
      this.axios
        .post(url, postData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(async res => {
          if (res.data.code == 200) {
            this.materialList = res.data.data
            if (this.detailsList.ORMTB440CC01) {
              this.materialValue = this.detailsList.ORMTB440CC01
              if (this.weightOpt.price === '' || this.weightOpt.price === null || this.weightOpt.price === undefined) {
                await this.queryMaterialPrice(this.materialValue)
              }
            } else {
              this.materialValue = this.detailsList.ORMTB440CA06
              await this.queryMaterialPrice(this.materialValue)
            }
            if (
              this.materialValue &&
              (this.weightOpt.tare || this.weightOpt.tare === 0) &&
              (this.weightOpt.gross || this.weightOpt.gross === 0) &&
              (this.weightOpt.price || this.weightOpt.price === 0)
            ) {
              this.getSettlementAmount()
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    //初始化数据
    init() {
      this.startTime = this.historyInfo.startTime
      this.endTime = this.historyInfo.endTime
      this.date = [this.startTime, this.endTime]
      this.ORMTB440CA02 = this.historyInfo.ORMTB440CA02
      this.ORMTB400CA03 = this.historyInfo.ORMTB400CA03
      this.ORMTB440CA04 = this.historyInfo.ORMTB440CA04
      this.ORMTB440CA06 = this.historyInfo.ORMTB440CA06
      this.ORMTB440CF01 = this.historyInfo.ORMTB440CF01
      this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
      this.ORMTB440CA01 = this.historyInfo.ORMTB440CA01
      this.currentPage = this.historyInfo.currentPage
      this.pageMo = this.historyInfo.pageMo
      this.limitMo = this.historyInfo.limitMo
      this.dateNowDayActive = this.historyInfo.dateNowDayActive
      this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
      this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
      this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
      this.ORMTB440CA00 = this.historyInfo.ORMTB440CA00
    },
    // 导出
    exports() {
      // console.log(this.uobj)
      let token = sessionStorage.getItem('token')
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        this.customerMo = this.uobj.ormtb410.ORMTB410ID //一级企业id
      }
      var startTime = this.date[0] //开始时间
      var endTime = this.date[1] //结束时间
      var ORMTB440CA02 = this.customerMo //二级客户ID
      var ORMTB400CA03 = 1002 //一级客户代码
      var ORMTB440CA04 = this.enterpriseTwo //二级企业ID
      var ORMTB440CA06 = this.materielMo //物料ID
      var ORMTB440CF01 = this.SETTB122CA07 //状态
      var ORMTB440CA00 = this.ORMTB440CA00 //订单号
      var ORMTB440CA01 = this.carNumber //车牌号
      var timeType = this.timeType //
      var type = this.orderCategory //订单类别
	  var source = this.orderSource//订单出处
      var areaOpen = this.areaOpen
      var url =
        this.axios.defaults.baseURL +
        '/exc/toExcel/ormtb440toExcle?startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&token=' +
        token +
        '&ORMTB440CA02=' +
        ORMTB440CA02 +
        '&ORMTB400CA03=' +
        ORMTB400CA03 +
        '&ORMTB440CA04=' +
        ORMTB440CA04 +
        '&ORMTB440CA06=' +
        ORMTB440CA06 +
        '&ORMTB440CF01=' +
        ORMTB440CF01 +
        '&ORMTB440CA00=' +
        ORMTB440CA00 +
        '&ORMTB440CA01=' +
        ORMTB440CA01 +
        '&timeType=' +
        timeType + '&type='+type+'&source='+source+'&areaOpen=' + areaOpen
      window.location.href = url
      console.log(url, 'oppp')
      this.loadingBut = true
      var timer = null //倒计时
      this.confirmTxt = 30 - 1
      timer = setInterval(() => {
        if (this.confirmTxt === 0) {
          this.confirmTxt = ''
          this.loadingBut = false
          clearInterval(timer)
        } else {
          this.confirmTxt--
        }
      }, 1000)
    },
    topWeightInput() {
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /[^\d.]/g,
        ''
      ) //清除“数字”和“.”以外的字符
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /^\./g,
        ''
      ) //验证第一个字符是数字
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /\.{2,}/g,
        '.'
      ) //只保留第一个. 清除多余的
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        '.',
        '$#$'
      )
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.detailsList.ORMTB440CE02 = this.detailsList.ORMTB440CE02.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      ) //只能输入两个小数
      if (
        this.detailsList.ORMTB440CE02.indexOf('.') < 0 &&
        this.detailsList.ORMTB440CE02 != ''
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.detailsList.ORMTB440CE02 = parseFloat(
          this.detailsList.ORMTB440CE02
        )
      }
      this.$refs.topWeight.value = this.detailsList.ORMTB440CE02
    },
    topWeightChange() {
      var index = String(this.detailsList.ORMTB440CE02).indexOf('.')
      if (index == -1) return
      var numArr = this.detailsList.ORMTB440CE02.split('.')
      if (numArr[1].length == 0) {
        this.$refs.topWeight.value = numArr[0]
        this.detailsList.ORMTB440CE02 = numArr[0]
      } else {
        this.$refs.topWeight.value = numArr[0] + '.' + numArr[1]
        this.detailsList.ORMTB440CE02 = numArr[0] + '.' + numArr[1]
      }
    },
    topMoneyInput() {
      //充值金额实时校验
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /[^\d.]/g,
        ''
      ) //清除“数字”和“.”以外的字符
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /^\./g,
        ''
      ) //验证第一个字符是数字
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /\.{2,}/g,
        '.'
      ) //只保留第一个. 清除多余的
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        '.',
        '$#$'
      )
        .replace(/\./g, '')
        .replace('$#$', '.')
      this.detailsList.ORMTB440CA21 = this.detailsList.ORMTB440CA21.replace(
        /^(\-)*(\d+)\.(\d\d).*$/,
        '$1$2.$3'
      ) //只能输入两个小数
      if (
        this.detailsList.ORMTB440CA21.indexOf('.') < 0 &&
        this.detailsList.ORMTB440CA21 != ''
      ) {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        this.detailsList.ORMTB440CA21 = parseFloat(
          this.detailsList.ORMTB440CA21
        )
      }
      this.$refs.topMoney.value = this.detailsList.ORMTB440CA21
    },
    topMoneyChange() {
      //充值金额失去焦点数据处理
      var index = String(this.detailsList.ORMTB440CA21).indexOf('.')
      if (index == -1) return
      var numArr = this.detailsList.ORMTB440CA21.split('.')
      if (numArr[1].length == 0) {
        this.$refs.topMoney.value = numArr[0]
        this.detailsList.ORMTB440CA21 = numArr[0]
      } else {
        this.$refs.topMoney.value = numArr[0] + '.' + numArr[1]
        this.detailsList.ORMTB440CA21 = numArr[0] + '.' + numArr[1]
      }
    },
    returnReceiptserve() {
      this.receiptSubmitAttempted = true
      if (!this.detailsList.ORMTB440CE02) {
        this.$message({
          message: '请输入回执重量',
          type: 'error',
        })
        this.focusField('topWeight')
        return
      }
      if (!this.detailsList.ORMTB440CA21) {
        this.$message({
          message: '请输入回执运费单价',
          type: 'error',
        })
        this.focusField('topMoney')
        return
      }
      if (this.receiptSubmitting) return
      this.receiptSubmitting = true
      var postData = {
        ORMTB440CE07: this.uobj.pertb005.pertb005id, //开始时间
        ORMTB440CE08: this.uobj.pertb005.pertb005ca02,
        ORMTB440CE09: this.detailsList.ORMTB440CE02,
        ORMTB440ID: this.detailsList.ORMTB440ID,
        ORMTB440CA21: this.detailsList.ORMTB440CA21,
      }
      var url = '/orm/ormtb440/ormtb440Confirm'
      this.axios
        .post(url, postData)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: '确认回执成功',
              type: 'success',
            })
            this.returnReceiptShow = false
            this.pageList({ source: 'action', silent: true })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            message: '回执提交失败，请稍后重试',
            type: 'error',
          })
        })
        .finally(() => {
          this.receiptSubmitting = false
        })
    },
    // 冻结或解冻
    djcancelOrder(row, datadj) {
      var url = '/orm/ormtb440/updateStatus'
      this.$prompt('请输入原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB440ID: row.ORMTB440ID,
          ORMTB440CA38: datadj, //状态
          ORMTB440CA39: value, //冻结解冻原因
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.axios
          .post(url, postData)
          .then(res => {
            if (res.data.code == 200) {
              this.pageList()
              this.$message({
                type: 'success',
                message: '成功!',
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
            loading.close()
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    // 取消订单
    cancelOrder(row) {
      var url = '/orm/ormtb440/updateORMTB440CF01'
      this.$prompt('请输入取消原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB440ID: row.ORMTB440ID,
          ORMTB440CF01: -1, //状态
          ORMTB440CD01: value, //取消原因
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.axios
          .post(url, postData)
          .then(res => {
            if (res.data.code == 200) {
              this.pageList()
              this.$message({
                type: 'success',
                message: '取消成功!',
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
            loading.close()
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    materielMoPost() {
      var i = (this.enterpriseTwoOptionList || []).findIndex(
        profile => profile.SETTB99ID === this.enterpriseTwo
      )
      var url = '/set/settb109/selectPageList'
      var SETTB100ID = this.enterpriseTwoOptionList[i].SETTB100ID
      var data = {
        SETTB109CA03: '',
        SETTB109CA00: '',
        SETTB109CD01: SETTB100ID,
        SETTB99ID: this.enterpriseTwo,
        page: 1,
        limit: 1000,
      }
      var List = [
        {
          SETTB109CA00: '全部',
          SETTB109ID: '',
        },
      ]
      this.axios.post(url, data).then(res => {
        if (res.data.code == 200) {
          this.materielOptions = [...List, ...res.data.data]
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    erpChange() {
      if (this.enterpriseTwo != '') {
        this.materielMoPost()
      } else {
        this.materielOptions = [
          {
            SETTB109CA00: '全部',
            SETTB109ID: '',
          },
        ]
      }
    },
    // 获取下拉框信息--二级企业
    optionLists() {
      var postData = {
        type: 1,
        SETTB100CA02: '', //用户类型
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-2') {
        postData = {
          type: 1,
          ORMTB400ID: this.uobj.ormtb410.ORMTB400ID, //一级企业id
        }
      }
      if (this.uobj.pertb005.pertb005cb00 == 'CUS-1') {
        postData = {
          type: 1,
          ORMTB400ID: this.uobj.ormtb400.ORMTB400ID, //一级企业id
        }
      }
      // var postData = {
      // 	SETTB100CA02: '', //用户类型
      // 	ORMTB400ID: this.uobj.ormtb400.ORMTB400ID //一级企业id
      // }
      var List = [
        {
          SETTB99ID: '',
          SETTB99CA00: '全部',
        },
      ]
      var url = '/set/settb100/selectSettb100ByCa02'
      this.axios
        .post(url, postData)
        .then(res => {
          if (res.data.code == 200) {
            var data = res.data.data
            // 二级企业
            this.enterpriseTwoOptionList = [...List, ...data]
            this.filteredEnterpriseOptions = this.enterpriseTwoOptionList.slice(0, 100)
            if (this.enterpriseTwoOptionList.length == 2) {
              this.enterpriseTwo = this.enterpriseTwoOptionList[1].SETTB99ID
              this.materielMoPost()
            }
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
          this.pageList()
        })
        .catch(() => {
          this.pageList()
        })
    },
    // 查询
    queryClick(options = {}) {
      this.applyCurrentDateRange()
      if (!options.keepPage) {
        this.pageMo = 1
        this.currentPage = 1
      }
      this.pageList({
        source: options.source || 'manual',
        silent: !!options.silent,
      })
    },
    // 列表
    pageList(options = {}) {
      const source = options.source || 'manual'
      const silent = !!options.silent
      const showOverlay = !silent && !this.hasLoadedOnce
      let loading = null

      if (source === 'auto' && this.isAnyDispatchDialogOpen) {
        return
      }

      if (showOverlay) {
        loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
      }

      this.initialLoading = !this.hasLoadedOnce
      this.tableLoading = true
      this.statsLoading = true
      this.isAutoRefreshing = source === 'auto'
      this.refreshError = false
      this.loadFailed = false

      var postData = {
        startTime: this.startTime, //开始时间
        endTime: this.endTime, //结束时间
        ORMTB440CA02: this.customerMo, //二级客户ID
        ORMTB440CA04: this.enterpriseTwo, //二级企业ID
        ORMTB440CA06: this.materielMo, //物料ID
        ORMTB440CF01: this.SETTB122CA07, //状态
        ORMTB440CA29: this.ORMTB440CA29, //状态
        ORMTB440CA00: this.ORMTB440CA00, //订单号
        ORMTB440CA01: this.carNumber, //车牌号
        ORMTB440CA37: this.lxorde, //离线订单
        ORMTB440CN00: this.xgorde, //修改订单
        ORMTB440CN05: this.cdorde, //错单
        // areaOpen: this.areaOpen, //运单信息是否展示
		type: this.orderCategory, //订单类别
		source: this.orderSource, //订单出处
        PERTB005ID: this.$store.state.uobj.pertb005.pertb005id, //角色ID
        page: this.pageMo,
        limit: this.limitMo,
        timeType: this.timeType,
      }
      var url = '/orm/ormtb440/selectPageList'
      this.axios
        .post(url, postData)
        .then(res => {
          if (loading) {
            setTimeout(() => {
              loading.close()
            }, 400)
          }
          if (res.data.code == 200) {
            var data = res.data.data.dataList || []
            this.pagingPageMo = res.data.count || 0
            for (var i = 0; i < data.length; i++) {
              if (data[i]['ORMTB440CF01'] == '-1') {
                data[i]['ORMTB440CF01text'] = '取消'
              } else if (data[i]['ORMTB440CF01'] == '0') {
                data[i]['ORMTB440CF01text'] = '待接单'
              } else if (data[i]['ORMTB440CF01'] == '1') {
                data[i]['ORMTB440CF01text'] = '待接单'
              } else if (data[i]['ORMTB440CF01'] == '2') {
                data[i]['ORMTB440CF01text'] = '提货中'
              } else if (data[i]['ORMTB440CF01'] == '3') {
                data[i]['ORMTB440CF01text'] = '完成'
              } else if (data[i]['ORMTB440CF01'] == '4') {
                data[i]['ORMTB440CF01text'] = '已回执'
              } else if (data[i]['ORMTB440CF01'] == '5') {
                data[i]['ORMTB440CF01text'] = '确认回执'
              } else if (data[i]['ORMTB440CF01'] == '-2') {
                data[i]['ORMTB440CF01text'] = '申请取消'
              } else if (data[i]['ORMTB440CF01'] == '6') {
                data[i]['ORMTB440CF01text'] = '申请完成'
              }
              if (data[i]['ORMTB440CF01'] == '-2') {
                if (data[i]['ORMTB440CG00'] == '0') {
                  data[i]['auditText'] = '未审核'
                } else if (data[i]['ORMTB440CG00'] == '1') {
                  data[i]['auditText'] = '通过'
                } else if (data[i]['ORMTB440CG00'] == '2') {
                  data[i]['auditText'] = '拒绝'
                }
              } else if (data[i]['ORMTB440CF01'] == '6') {
                data[i]['auditText'] = '未审核'
              } else {
                if (data[i].ORMTB440CH00 == 0) {
                  data[i].isauditOrder = 0
                }
                if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 0) {
                  data[i].isauditOrder = 1
                }
                if (data[i].ORMTB440CH00 == 1 && data[i].ORMTB440CH01 == 1) {
                  data[i].isauditOrder = 0
                }
                if (data[i]['ORMTB440CH01'] == '0') {
                  data[i]['auditText'] = '未审核'
                } else if (data[i]['ORMTB440CH01'] == '1') {
                  data[i]['auditText'] = '通过'
                } else if (data[i]['ORMTB440CH01'] == '2') {
                  data[i]['auditText'] = '拒绝'
                }
              }

              data[i]['msgFlag'] = 0
              if (data[i]['ORMTB440CA32'] != null) {
                try {
                  let dataJs = JSON.parse(data[i]['ORMTB440CA32'])
                  data[i]['msgFlag'] = dataJs.errcode
                } catch {
                  data[i]['msgFlag'] = 1
                }
              }
            }
            this.tableData = data
            this.jscc = res.data.data.jscc
            this.jsje = res.data.data.jsje
            this.jszl = res.data.data.jszl
            this.pdcc = res.data.data.pdcc
            this.pdje = res.data.data.pdje
            this.pdzl = res.data.data.pdzl
            this.hasLoadedOnce = true
            this.lastRefreshSource = source
            this.lastRefreshTime = this.formatRefreshTime(new Date())
            this.refreshError = false
          } else {
            this.loadFailed = !this.hasLoadedOnce
            this.refreshError = this.hasLoadedOnce
            if (source !== 'auto') {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
          }
        })
        .catch(() => {
          if (loading) {
            loading.close()
          }
          this.loadFailed = !this.hasLoadedOnce
          this.refreshError = this.hasLoadedOnce
          if (source !== 'auto') {
            this.$message({
              message: '派单数据请求失败，请稍后重试',
              type: 'error',
            })
          }
        })
        .finally(() => {
          this.initialLoading = false
          this.tableLoading = false
          this.statsLoading = false
          this.isAutoRefreshing = false
        })
    },
    UploadClick(row) {
      this.ormtb440ca00 = row.ORMTB440ID
      this.$nextTick(() => {
        if (this.$refs.dispatchUploadInput) {
          this.$refs.dispatchUploadInput.value = ''
          this.$refs.dispatchUploadInput.click()
        }
      })
    },
    hasDispatchPermission(actionId) {
      if (!actionId) return true
      return this.solelist.some(item => item.PERTB001CA00 == actionId)
    },
    hasDispatchActions(row) {
      if (!row) return false
      return (
        (row.ORMTB440CF01 == '-2' && row.ORMTB440CG00 == 0 && this.hasDispatchPermission('审核取消')) ||
        (row.isauditOrder == 1 && this.hasDispatchPermission('审核派单')) ||
        (row.ORMTB440CF01 == 4 && row.ORMTB440CF00 == 'ZG' && this.hasDispatchPermission('确认回执')) ||
        (row.ORMTB440CA29 == 1 && row.ORMTB440CA30 == 0) ||
        (row.ORMTB440CA29 == 1) ||
        (row.ORMTB401CA01 === 'ZJ' && row.ORMTB440CF01 >= 0 && row.ORMTB440CF01 < 3) ||
        ((row.ORMTB401CA01 == 'ZJ' || row.ORMTB440CA42 == '1') &&
          (row.ORMTB440CF01 == 0 || row.ORMTB440CF01 == 2 || row.ORMTB440CF01 == 6)) ||
        ((row.ORMTB440CF01 == 0 || row.ORMTB440CF01 == 1 || row.ORMTB440CF01 == 2) &&
          row.isauditOrder == 0 && this.hasDispatchPermission('取消订单')) ||
        ((row.ORMTB440CF01 == 0 || row.ORMTB440CF01 == 1 || row.ORMTB440CF01 == 2) &&
          row.ORMTB440CA38 == 0 && this.hasDispatchPermission('冻结')) ||
        ((row.ORMTB440CF01 == 0 || row.ORMTB440CF01 == 1 || row.ORMTB440CF01 == 2 || row.ORMTB440CF01 == -1) &&
          row.ORMTB440CA38 == 1 && this.hasDispatchPermission('解冻')) ||
        row.ORMTB440CF01 == 3
      )
    },
    handleDispatchAction(command, row) {
      if (command == 'cancelOrder') {
        this.cancelOrder(row)
      } else if (command == 'freeze') {
        this.djcancelOrder(row, 1)
      } else if (command == 'mistakeOrder') {
        this.cdclDetailsClick(row)
      } else if (command == 'unfreeze') {
        this.djcancelOrder(row, 0)
      } else if (command == 'auditCancel') {
        this.orderAudit(row)
      } else if (command == 'auditDispatch') {
        this.isorderAudit(row)
      } else if (command == 'receipt') {
        this.returnReceipt(row)
      } else if (command == 'pushMsg') {
        this.pushMsg(row)
      } else if (command == 'settlement') {
        this.completeClick(row)
      } else if (command == 'qrCode') {
        this.ewmDetailsClick(row)
      } else if (command == 'uploadQr') {
        this.UploadClick(row)
      } else if (command == 'completeOrder') {
        this.inputWeightClick(row)
      }
    },
    inputFileChange(e) {
      let file = e.target.files[0]
      let formData = new FormData()
      formData.append('file', file)
      formData.append('ormtb440id', this.ormtb440ca00)
      let loading = this.$loading({
        lock: true,
        text: '上传中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
      })
      var url = '/orm/ormtb440/upload'
      this.axios
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(res => {
          setTimeout(() => {
            loading.close()
          }, 400)
          if (res.data.code == 200) {
            this.$message({
              message: '上传成功',
              type: 'success',
            })
            this.pageList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          loading.close()
        })
    },
    inputWeightClick(row) {
      // console.log(row)
      if (
        row.ORMTB440CA04 == '10000108' ||
        row.ORMTB440CA04 == '10000145' ||
        row.ORMTB440CA04 == '10000146' ||
        row.ORMTB440CA04 == '10000107'
      ) {
        this.distf = false
        this.dcmoreID = row.ORMTB440CA04
      } else {
        this.distf = true
      }
      this.completeSubmitting = false
      this.completeSubmitAttempted = false
      this.settlementAmountLoading = false
      this.inputWeightShow = true
      // console.log(this.fileList)
      this.fileList = []
      this.ruleForm.csAvatar = ''
      this.ruleForm.fileId = ''
      this.querydetile(row, true, false)
      this.settlementAmountLoading = false
      this.weightOpt.tare = ''
      this.weightOpt.gross = ''
    },
    inputWeightClose() {
      this.completeSubmitAttempted = false
      this.completeSubmitting = false
      this.settlementAmountLoading = false
      this.materialValue = ''
      this.weightOpt.tare = ''
      this.weightOpt.gross = ''
      this.weightOpt.price = ''
      this.ruleForm.csAvatar = ''
      this.ruleForm.fileId = ''
    },
    // 获取结算金额
    async getSettlementAmount() {
      if (!this.materialValue || !this.detailsList) return
      if (this.weightOpt.price < 0) return
      if (!this.detailsList.ORMTB440CC04 || parseFloat(this.detailsList.ORMTB440CC04) < 0) {
        this.detailsList.ORMTB440CC06 = ''
        return
      }
      var params = {
        ORMTB440CC01: this.materialValue,
        ORMTB440CA02: this.detailsList.ORMTB440CA02,
        ORMTB440CA04: this.detailsList.ORMTB440CA04,
        ORMTB440CC03: this.detailsList.ORMTB440CC03,
        ORMTB440CC04: this.detailsList.ORMTB440CC04,
        ORMTB440CC03: this.weightOpt.price,
      }
      params = qs.stringify(params)
      this.settlementAmountLoading = true
      var url = '/orm/ormtb440/orderCompleteBeforeBack'
      this.axios
        .post(url, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(res => {
          if (res.data.code == 200) {
            this.detailsList.ORMTB440CC06 = res.data.data
          } else {
            this.detailsList.ORMTB440CC06 = ''
          }
        })
        .catch(() => {
          this.detailsList.ORMTB440CC06 = ''
        })
        .finally(() => {
          this.settlementAmountLoading = false
        })
    },
    inputWeightConfirm() {
      this.completeSubmitAttempted = true
      var {
        ORMTB440ID, // 派单记录ID - 隐藏
        ORMTB440CC04, // 结算重量 -不修改
      } = this.detailsList
      var ORMTB440CC01 = this.materialValue // 物料id
      var selectedMaterial = this.materialList.find(
        em => em.value === this.materialValue
      )
      var ORMTB440CA07 = selectedMaterial ? selectedMaterial.lable : '' // 结算物料 -可修改

      var { tare, gross, price } = this.weightOpt
      if (!ORMTB440CC01) {
        return this.$message({
          message: '请选择派单物料',
          type: 'error',
        })
      }
      if (price === '' || price === null || price === undefined) {
        this.$message({
          message: '请输入单价',
          type: 'error',
        })
        this.focusField('completePrice')
        return
      }
      if (!tare) {
        this.$message({
          message: '请输入毛重',
          type: 'error',
        })
        this.focusField('completeGross')
        return
      }
      if (!gross) {
        this.$message({
          message: '请输入皮重',
          type: 'error',
        })
        this.focusField('completeTare')
        return
      }
      if (parseFloat(ORMTB440CC04) < 0) {
        this.$message({
          message: '毛重必须大于或等于皮重',
          type: 'error',
        })
        this.focusField('completeGross')
        return
      }
      if (
        this.detailsList.ORMTB440CA04 == '10000106' ||
        this.detailsList.ORMTB440CA42 == '1'
      ) {
        if (this.ruleForm.csAvatar == '') {
          return this.$message({
            message: '请上传出厂磅单',
            type: 'error',
          })
        }
      }
      this.dcmore = this.detailsList.ORMTB440CC06
      if (this.completeSubmitting) return
      this.completeSubmitting = true
      var params = {
        ORMTB440ID,
        ORMTB440CC01, // 物料id
        ORMTB440CC02: ORMTB440CA07,
        ORMTB440CC04,
        ORMTB440CC06: this.dcmore,
        ORMTB440CC03: this.weightOpt.price,
        ORMTB440CL01: this.ruleForm.csAvatar,
        fileId: this.ruleForm.fileId
      }
      params = qs.stringify(params)

      var url = '/orm/ormtb440/update'
      this.axios
        .post(url, params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        })
        .then(res => {
          if (res.data.code == 200) {
            this.ruleForm.csAvatar = ''
            this.ruleForm.fileId = ''
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            this.inputWeightShow = false
            this.pageList({ source: 'action', silent: true })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            message: '提交失败，请稍后重试',
            type: 'error',
          })
        })
        .finally(() => {
          this.completeSubmitting = false
        })
    },
    inputWeightFormat(e, type) {
      let value = e.target.value
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/^\./g, '') //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }
      this.weightOpt[type] = value
    },
    inputWeightTotalFormat(e) {
      let value = e.target.value
      value = value.replace(/[^\d.]/g, '') //清除“数字”和“.”以外的字符
      value = value.replace(/^\./g, '') //验证第一个字符是数字
      value = value.replace(/\.{2,}/g, '.') //只保留第一个. 清除多余的
      value = value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.')
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value)
      }
      this.detailsList.ORMTB440CC06 = value
    },
    // 详情
    handleDispatchRowClick(row) {
      this.DetailsClick(row)
    },
    DetailsClick(row) {
		if(row.type == '1'){
			this.oerderDetilsShow = true
		}
		else{
			this.transportOerderDetilsShow = true
		}
      this.querydetile(row, false)
    },

    cdclDetailsClick(row) {//错单描述
      var url = '/orm/ormtb440/updateCn05ById'
      this.$prompt('请输入错单原因', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^.{1,}$/,
        inputErrorMessage: '原因不能为空',
      }).then(({ value }) => {
        var postData = {
          ORMTB440ID: row.ORMTB440ID,
          ORMTB440CN05: value, //错单描述
        }
        let loading = this.$loading({
          lock: true,
          text: '请求中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)',
        })
        this.axios
          .post(url, postData)
          .then(res => {
            if (res.data.code == 200) {
              this.pageList()
              this.$message({
                type: 'success',
                message: res.data.message,
              })
            } else {
              this.$message({
                message: res.data.message,
                type: 'error',
              })
            }
            loading.close()
          })
          .catch(() => {
            loading.close()
          })
      })
    },

    ewmDetailsClick(row) {
      this.ewmDetilsShow = true
      this.queryermdetile(row)
    },
    orderAudit(row) {
      this.auditSubmitting = false
      this.orderAuditShow = true
      this.querydetile(row, false, false)
    },
    isorderAudit(row) {
      this.dispatchAuditSubmitting = false
      this.isorderAuditText = ''
      this.isorderAuditShow = true
      this.querydetile(row, false, false)
    },
    returnReceipt(row) {
      this.receiptSubmitting = false
      this.receiptSubmitAttempted = false
      this.returnReceiptShow = true
      this.querydetile(row, false, false)
    },
    // 完成订单
    pushMsg(row) {
      var postData = {
        ORMTB440ID: row.ORMTB440ID, //流水id
      }
      var url = '/orm/ormtb440/sendMsg'
      this.$confirm('此操作将推送支付消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.axios.post(url, postData).then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.pageList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
      })
    },
    completeClick(row) {
      var postData = {
        ORMTB440ID: row.ORMTB440ID, //流水id
      }
      var url = '/orm/ormtb440/updatePayStatus'
      this.$confirm('此操作将完成该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.axios.post(url, postData).then(res => {
          // console.log(res)
          if (res.data.code == 200) {
            this.pageList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
      })
    },
    handleOrderAuditAction(type) {
      if (this.auditSubmitting) return
      if (type === 2) {
        this.$confirm('确认拒绝该审核申请吗？', '提示', {
          confirmButtonText: '确定拒绝',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.orderAuditServe(type)
        }).catch(() => {})
        return
      }
      this.orderAuditServe(type)
    },
    orderAuditServe(type) {
      if (this.auditSubmitting) return
      this.auditSubmitting = true
      var postData = {
        ORMTB440CG00: type,
        ORMTB440CG02: this.uobj.pertb005.pertb005ca02,
        ORMTB440ID: this.detailsList.ORMTB440ID,
        ORMTB440CA02: this.detailsList.ORMTB440CA02,
        ORMTB440CA11: this.detailsList.ORMTB440CA11,
        ORMTB440CA12: this.detailsList.ORMTB440CA12,
      }
      var url = '/orm/ormtb440/updateORMTB440CG00'
      this.axios
        .post(url, postData)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.orderAuditShow = false
            this.pageList({ source: 'action', silent: true })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            message: '审核提交失败，请稍后重试',
            type: 'error',
          })
        })
        .finally(() => {
          this.auditSubmitting = false
        })
    },
    handleDispatchAuditAction(type) {
      if (this.dispatchAuditSubmitting) return
      if (type === 2 && !this.isorderAuditText) {
        this.$message({
          message: '拒绝前请填写审核说明',
          type: 'warning',
        })
        this.focusField('dispatchAuditReason')
        return
      }
      if (type === 2) {
        this.$confirm('确认拒绝该派单审核吗？', '提示', {
          confirmButtonText: '确定拒绝',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(() => {
          this.isorderAuditServe(type)
        }).catch(() => {})
        return
      }
      this.isorderAuditServe(type)
    },
    isorderAuditServe(type) {
      if (this.dispatchAuditSubmitting) return
      this.dispatchAuditSubmitting = true
      var postData = {
        ORMTB440CH01: type,
        ORMTB440CH03: this.uobj.pertb005.pertb005ca02,
        ORMTB440ID: this.detailsList.ORMTB440ID,
        ORMTB440CA02: this.detailsList.ORMTB440CA02,
        ORMTB440CA11: this.detailsList.ORMTB440CA11,
        ORMTB440CA12: this.detailsList.ORMTB440CA12,
        ORMTB440CH04: this.isorderAuditText,
      }
      var url = '/orm/ormtb440/updateORMTB440CH01'
      this.axios
        .post(url, postData)
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: '审核成功',
              type: 'success',
            })
            this.isorderAuditShow = false
            this.pageList({ source: 'action', silent: true })
          } else {
            this.$message({
              message: res.data.message,
              type: 'error',
            })
          }
        })
        .catch(() => {
          this.$message({
            message: '审核提交失败，请稍后重试',
            type: 'error',
          })
        })
        .finally(() => {
          this.dispatchAuditSubmitting = false
        })
    },
    querydetile(row, loadMaterial = true, loadCdlx = true) {
      var postData = {
        ORMTB440ID: row.ORMTB440ID, //流水id
        type: row.type
      }
      this.detailsList = ''
      var url = '/orm/ormtb440/selectDetails'
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {
          this.detailsList = res.data.data

		  if(row.type =='2'){
			   this.transportDetailsList = res.data.data
		  }

          this.DetailsWatersrcList = [this.detailsList.ORMTB440CE01]
          if (this.detailsList.ORMTB440CH05)
            this.DetailsWeightrcList = [this.detailsList.ORMTB440CH05]
          if (this.detailsList.ORMTB440CL01)
            this.DetailsWeightrcBDList = [this.detailsList.ORMTB440CL01]
          this.DetailsWaterurl = this.detailsList.ORMTB440CE01

          if (loadMaterial) {
            if (
              this.detailsList.ORMTB440CF01 == 6 ||
              (row.ORMTB440CF01 == 0 && row.ORMTB440CA22)
            ) {
              this.weightOpt.price = this.detailsList.ORMTB440CC03
              if (this.detailsList.ORMTB440CC06 == 0)
                this.detailsList.ORMTB440CC06 = ''
              this.weightOpt.tare = this.detailsList.ORMTB440CC05
              this.weightOpt.gross = (
                this.detailsList.ORMTB440CC05 - this.detailsList.ORMTB440CC04
              ).toFixed(2)
              this.getSelectMaterial()
            }
          }
          if (loadCdlx) {
            this.cdlxFun()
          }
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },

    cdlxFun() {//错单类型
      var url = '/set/settb206/selectSETTB206List'
      var postData = {
        SETTB205ID: '15',
      }
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {

          console.log(res)
          this.cdlxList = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    queryermdetile(row) {
      var postData = {
        ORMTB440ID: row.ORMTB440ID, //流水id
      }
      this.detailsList = ''
      var url = '/orm/ormtb440/getErwei'
      this.axios.post(url, postData).then(res => {
        if (res.data.code == 200) {
          this.ewmdetailsList = res.data.data
          this.ewmdetailsList.ORMTB440CA22Img =
            'data:image/png;base64,' + res.data.data.ORMTB440CA22
        } else {
          this.$message({
            message: res.data.message,
            type: 'error',
          })
        }
      })
    },
    updateDispatchTableLayout() {
      this.$nextTick(() => {
        if (this.$refs.dispatchTable) {
          this.$refs.dispatchTable.doLayout()
        }
      })
    },

    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities : []
      this.isIndeterminate = false
      this.tableHeadList = val ? this.tableHeadListInit : []
      this.updateDispatchTableLayout()
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length
      var changearr = this.checkedCities
      var initarr = this.tableHeadListInit
      this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr)
      this.updateDispatchTableLayout()
    },

    dateFtt(fmt, date) {
      //author: meizz
      var o = {
        'M+': date.getMonth() + 1, //月份
        'd+': date.getDate(), //日
        'h+': date.getHours(), //小时
        'm+': date.getMinutes(), //分
        's+': date.getSeconds(), //秒
        'q+': Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
      }
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      for (var k in o)
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
      return fmt
    },

    //获取当前时间
    getNowDay() {
      var date = new Date().getTime()
      var Ming = new Date().getTime() + 24 * 60 * 60 * 1000
      var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
      var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
      data = `${data} ${this.exchangeTiem || '00:00:00'}`
      enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
      this.date = [enddata, data]
      this.dateNowDayActive = true
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    datePickerChange(e) {
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取昨天时间
    getYesterday() {
      var hms = new Date().getTime() - 24 * 60 * 60 * 1000
      var Ming = new Date().getTime()
      var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
      var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
      nowDay = `${nowDay} ${this.exchangeTiem || '00:00:00'}`
      enddata = `${enddata} ${this.exchangeTiem || '00:00:00'}`
      this.date = [nowDay, enddata]
      this.dateNowDayActive = false
      this.dateYesterdayActive = true
      this.dateNowMonthActive = false
      this.dateLastMonthActive = false
    },
    //获取当月时间
    sameMonth() {
      var date = new Date()
      var hms = date.setDate(1)
      var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
      firstDay = `${firstDay} ${this.exchangeTiem || '00:00:00'}`
      var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000
      var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate))
      nextDay = `${nextDay} ${this.exchangeTiem || '00:00:00'}`
      this.date = [firstDay, nextDay]
      this.startTime = this.date[0]
      this.endTime = this.date[1]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = true
      this.dateLastMonthActive = false
    },
    //获取上月时间
    lastMonth() {
      var nowdays = new Date()
      var year = nowdays.getFullYear()
      var month = nowdays.getMonth()
      var lastyear = year
      var lastmonth = month
      if (month == 0) {
        month = 12
        year = year - 1
      }
      if (month == 12) {
        lastmonth = 1
      } else {
        lastmonth = lastmonth + 1 * 1
      }
      if (month < 10) {
        month = '0' + month
      }
      if (lastmonth < 10) {
        lastmonth = '0' + lastmonth
      }
      var firstDayOfPreMonth = year + '-' + month + '-' + '01'
      var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem ||
        '00:00:00'}`
      // var lastDay = new Date(lastyear, lastmonth, 0);
      let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this
        .exchangeTiem || '00:00:00'}`
      this.date = [firstDayOfPreMonth, lastDayOfPreMonth]
      this.dateNowDayActive = false
      this.dateYesterdayActive = false
      this.dateNowMonthActive = false
      this.dateLastMonthActive = true
    },
    handleSizeChange(val) {
      this.pageMo = 1
      this.currentPage = 1
      this.limitMo = val
      this.pageList({ source: 'pagination' })
    },
    // 点击页码
    handleCurrentChange(val) {
      this.pageMo = val
      this.currentPage = val
      this.pageList({ source: 'pagination' })
    },
  },
}
</script>

<style scoped>
.CustomerfillingDig-tab {
  padding-left: 20px;
}

.CustomerfillingDig-tab-li,
.rechargeType-tab-li {
  display: flex;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 16px;
  color: #333;
  vertical-align: top;
}

.CustomerfillingDig-tab-li>div {
  border: 1px solid #cdcdcd;
  border-top: none;
}

.CustomerfillingDig-tab-li>div:first-child {
  border-right: none;
}

.CustomerfillingDig-tab-li:first-child>div {
  border-top: 1px solid #cdcdcd;
}

.CustomerfillingDig-tab-li>div:last-child,
.rechargeType-tab-li>div:last-child {
  border: none;
  color: #ff4d35;
}

.CustomerfillingDig-tab-li-text {
  flex: 0.8;
  background: rgba(240, 252, 255, 1);
}

.dispatch-required-text {
  color: #d44f3e;
  font-weight: 600;
}

.CustomerfillingDig-tab-li-ipt {
  flex: 0.8;
}

.rechargeType-tab-li-text {
  flex: 0.35;
}

.rechargeType-tab-li-ipt {
  flex: 0.7;
}

.CustomerfillingDig-tab-li-ipt input,
.rechargeType-tab-li-ipt input {
  height: 46px;
  width: 100%;

  text-align: center;

  box-sizing: border-box;
  font-size: 16px;
  color: #333;
}

.CustomerfillingDig-tab-li-ipt input {
  outline: none;
  border: none;
  vertical-align: top;
}

.rechargeType-tab-li-ipt input {
  /* border-radius: 8px; */
  /* outline: none; */
}

.CustomerfillingDig-tab-li-b,
.rechargeType-tab-li-b {
  flex: 0.3;
}

.CustomerfillingDig-tab-btn {
  text-align: center;
  margin-top: 30px;
}

.DWD-li {
  display: flex;
  height: 35px;
  line-height: 35px;
  box-sizing: border-box;
  border: 1px solid #999;
  font-size: 16px;
  color: #333;
}

.DWD-li>div {
  padding: 0 5px;
  height: 34px;
  overflow: hidden;
  box-sizing: border-box;
}

.DWD-li-title {
  width: 150px;
  text-align: center;
  border-right: 1px solid #999;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-li-text {
  flex: 1;
}

.DWD-li-text input {
  width: 100%;
  height: 35px;
  line-height: 35px;
  border: none;
  outline: none;
}

.DWD-li+.DWD-li {
  border-top: none;
}

.DWD-table {
  display: flex;
}

.DWD-table-left-flex {
  flex: 1;
}

.DWD-table>div>div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  text-align: center;
  border-right: 1px solid #999;
  border-bottom: 1px solid #999;
  box-sizing: border-box;
}

.DWD-table>div>div:first-child {
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table-left-title>div {
  width: 101px;
  text-align: center;
  background-color: rgba(0, 163, 255, 0.1);
}

.DWD-table .DWD-table-left-title>div {
  padding: 0 5px;
  height: 35px;
  line-height: 35px;
  overflow: hidden;
  box-sizing: border-box;
  border-left: 1px solid #999;
  border-bottom: 1px solid #999;
}

.DetailsWater-img {
  margin-top: 30px;
}

.DetailsWater-img-text {
  display: inline-block;
  width: 101px;
  text-align: center;
  vertical-align: top;
}

.dispatch-dialog-intro {
  margin-bottom: 16px;
  padding: 14px 16px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(24, 144, 255, 0.1), rgba(24, 144, 255, 0.04));
}

.dispatch-dialog-intro-title {
  font-size: 15px;
  font-weight: 600;
  color: #244868;
}

.dispatch-dialog-intro-desc {
  margin-top: 6px;
  font-size: 13px;
  line-height: 1.6;
  color: #5f7288;
}

.dispatch-complete-plate {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: -6px 84px 8px 0;
  font-size: 14px;
  line-height: 20px;
  color: #5f7288;
}

.dispatch-complete-plate strong {
  color: #244868;
  font-weight: 600;
}

.dispatch-detail-grid {
  margin-bottom: 16px;
}

.dispatch-summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.dispatch-summary-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border: 1px solid rgba(196, 214, 232, 0.9);
  border-radius: 10px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.dispatch-summary-item-full {
  grid-column: 1 / -1;
}

.dispatch-summary-label {
  font-size: 12px;
  color: #5f7288;
}

.dispatch-summary-value {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.6;
  color: #1f2d3d;
  word-break: break-all;
}

.dispatch-summary-value-multiline {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dispatch-summary-item-state {
  position: relative;
  padding-left: 14px !important;
}

.dispatch-summary-item-state::before {
  position: absolute;
  top: 10px;
  bottom: 10px;
  left: 0;
  width: 4px;
  border-radius: 4px;
  content: '';
}

.dispatch-summary-item-state.is-filled {
  border-color: rgba(23, 139, 255, 0.75);
  background: linear-gradient(180deg, #eff8ff 0%, #e3f2ff 100%);
  box-shadow: 0 4px 12px rgba(23, 139, 255, 0.12);
}

.dispatch-summary-item-state.is-filled::before {
  background: #178bff;
}

.dispatch-summary-item-state.is-empty {
  border-style: dashed;
  border-color: rgba(180, 190, 204, 0.95);
  background: repeating-linear-gradient(-45deg, #f8fafc 0, #f8fafc 8px, #f1f4f8 8px, #f1f4f8 16px);
}

.dispatch-summary-item-state.is-empty::before {
  background: #b4becc;
}

.dispatch-summary-value-filled {
  color: #0b7adf;
  font-weight: 700;
}

.dispatch-summary-value-empty {
  color: #8a97a6;
  font-weight: 500;
}

.dispatch-dialog-block-title {
  margin-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  color: #244868;
}

.dispatch-dialog-block-title-spaced {
  margin-top: 20px;
}

.dispatch-dialog-table,
.dispatch-dialog-table-spaced {
  overflow-x: auto;
}

.dispatch-dialog-table-spaced {
  margin-top: 8px;
}

/* ---- 两栏整体布局 ---- */
.dispatch-detail-layout {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.dispatch-detail-left {
  flex: 0 0 30%;
  max-height: calc(72vh - 120px);
  padding-right: 8px;
  overflow-y: auto;
}

.dispatch-detail-right {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.dispatch-detail-col-title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #244868;
}

/* 左列单列信息格 */
.dispatch-summary-grid-single {
  grid-template-columns: 1fr !important;
  gap: 6px !important;
}

.dispatch-summary-grid-single .dispatch-summary-item {
  padding: 9px 12px !important;
}

/* 右列：派单/结算左右并排 */
.dispatch-compare-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

/* 右列：磅单图片并排 */
.dispatch-detail-images {
  display: flex;
  gap: 12px;
  margin-top: 12px;
  flex-wrap: wrap;
}

.dispatch-detail-images .dispatch-dialog-figure {
  margin-top: 0;
}

/* 保留旧的 stack 类以防其他地方引用 */
.dispatch-compare-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.dispatch-compare-card {
  padding: 12px;
  border: 1px solid rgba(196, 214, 232, 0.9);
  border-radius: 10px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
}

.dispatch-compare-card-secondary {
  background: linear-gradient(180deg, #ffffff 0%, #f6f9fd 100%);
}

.dispatch-compare-card-title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: 600;
  color: #244868;
}

.dispatch-compare-list {
  display: grid;
  gap: 8px;
}

.dispatch-compare-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 10px;
  border-radius: 8px;
  background: rgba(244, 248, 252, 0.95);
}

.dispatch-compare-label {
  color: #5f7288;
  font-size: 12px;
}

.dispatch-compare-value {
  text-align: right;
  font-size: 13px;
  font-weight: 600;
  color: #1f2d3d;
  word-break: break-all;
}

.dispatch-dialog-figure {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
  padding: 14px 16px;
  border: 1px solid rgba(196, 214, 232, 0.9);
  border-radius: 10px;
  background: #f8fbff;
}

.dispatch-dialog-figure-center {
  justify-content: center;
}

.dispatch-dialog-figure .DetailsWater-img-text {
  width: auto;
  min-width: 72px;
  text-align: left;
  font-weight: 600;
  color: #4f6278;
}

.dispatch-dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 20px;
}

.dispatch-dialog-footer-split {
  justify-content: space-between;
}

.dispatch-dialog-footer-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.dispatch-dialog-input-row {
  min-height: 47px;
  height: auto;
  align-items: stretch;
}

.dispatch-dialog-input-row .DWD-li-title {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dispatch-dialog-input-row .DWD-li-text {
  display: flex;
  align-items: center;
  padding: 6px 10px;
}

.dispatch-form-grid {
  padding-left: 0;
}

.dispatch-form-grid .CustomerfillingDig-tab-li {
  min-height: 50px;
  height: auto;
  line-height: normal;
}

.dispatch-form-grid .CustomerfillingDig-tab-li-text,
.dispatch-form-grid .CustomerfillingDig-tab-li-b {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dispatch-form-grid .CustomerfillingDig-tab-li-ipt {
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.dispatch-form-grid .CustomerfillingDig-tab-li-ipt input {
  padding: 0 10px;
  text-align: left;
}

.dispatch-form-grid .Customer-upload-bd {
  padding: 16px 0 0;
}

.dispatch-form-feedback {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f6f8fb;
  color: #5f7288;
  font-size: 13px;
  line-height: 1.6;
}

.dispatch-form-feedback span:last-child {
  text-align: right;
}

.dispatch-form-feedback-highlight {
  gap: 14px;
  padding: 0;
  background: transparent;
}

.dispatch-form-feedback-emphasis {
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 12px 14px;
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fbff 0%, #eef5ff 100%);
  border: 1px solid rgba(82, 144, 255, 0.18);
  color: #24507a;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.5;
  box-shadow: 0 6px 16px rgba(36, 93, 150, 0.08);
}

.dispatch-form-feedback-emphasis.is-primary {
  justify-content: flex-end;
  text-align: right;
  color: #1f3d61;
  background: linear-gradient(180deg, #f7fbff 0%, #eaf3ff 100%);
}

.dispatch-form-feedback-emphasis.is-pending {
  color: #7a5a12;
  border-color: rgba(214, 160, 22, 0.22);
  background: linear-gradient(180deg, #fffdf6 0%, #fff7df 100%);
}

.dispatch-form-feedback-emphasis.is-loading {
  color: #4f6278;
}

.dispatch-form-feedback-emphasis.is-error {
  color: #d44f3e;
  border-color: rgba(212, 79, 62, 0.22);
  background: linear-gradient(180deg, #fff8f7 0%, #fff0ee 100%);
}

.dispatch-form-feedback-emphasis.is-ready {
  color: #1f3d61;
}

.dispatch-form-row-error > div:first-child,
.dispatch-form-row-error > div:last-child {
  color: #d44f3e;
}

.dispatch-form-row-error .CustomerfillingDig-tab-li-ipt {
  box-shadow: inset 0 0 0 1px rgba(212, 79, 62, 0.35);
}

.dispatch-transport-layout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.dispatch-transport-panel {
  width: auto;
  background: #f8fbff;
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #dde9f5;
}

.dispatch-transport-panel .dispatch-dialog-block-title {
  font-size: 15px;
  font-weight: 700;
  color: #178bff;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 2px solid #d0e8fb;
}

.dispatch-transport-panel .DWD-li {
  position: relative;
  display: flex;
  min-height: 38px;
  margin-bottom: 8px;
  overflow: hidden;
  border: 1px solid #eaf2fb;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
}

.dispatch-transport-panel .DWD-li::before {
  flex: none;
  width: 4px;
  content: '';
}

.dispatch-transport-panel .DWD-li:last-child {
  margin-bottom: 0;
}

.dispatch-transport-panel .DWD-li.is-filled {
  border-color: rgba(23, 139, 255, 0.65);
  background: linear-gradient(180deg, #f2f9ff 0%, #e7f4ff 100%);
  box-shadow: 0 3px 10px rgba(23, 139, 255, 0.1);
}

.dispatch-transport-panel .DWD-li.is-filled::before {
  background: #178bff;
}

.dispatch-transport-panel .DWD-li.is-empty {
  border-style: dashed;
  border-color: rgba(180, 190, 204, 0.95);
  background: repeating-linear-gradient(-45deg, #f8fafc 0, #f8fafc 8px, #f1f4f8 8px, #f1f4f8 16px);
}

.dispatch-transport-panel .DWD-li.is-empty::before {
  background: #b4becc;
}

.dispatch-transport-panel .DWD-li-title {
  flex: 0 0 auto;
  min-width: 90px;
  max-width: 160px;
  width: auto;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: 700;
  color: #1a4a7a;
  background: transparent;
  border-right: none;
  text-align: left;
  justify-content: flex-start;
}

.dispatch-transport-panel .DWD-li-text {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  font-size: 15px;
  font-weight: 700;
  color: #0a1e30;
  word-break: break-all;
}

.dispatch-transport-panel .DWD-li.is-filled .DWD-li-text {
  color: #0b7adf;
}

.dispatch-transport-panel .DWD-li.is-empty .DWD-li-title,
.dispatch-transport-panel .DWD-li.is-empty .DWD-li-text {
  color: #8a97a6;
}

.dispatch-dialog-block-title-spaced {
  margin-top: 20px;
  padding: 10px 14px;
  background: #f0f7ff;
  border-radius: 8px;
  border-left: 4px solid #178bff;
  font-size: 15px;
  font-weight: 700;
  color: #178bff;
}

.dispatch-dialog-table .DWD-table-left-title > div {
  background: linear-gradient(180deg, #1a4a7a, #1e5a96);
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  border-radius: 0;
  height: 42px;
  line-height: 42px;
}

.dispatch-dialog-table .DWD-table > div > div {
  border: 1px solid #dde9f5;
  font-size: 14px;
  font-weight: 600;
  color: #0a1e30;
  height: 42px;
  line-height: 42px;
}

.dispatch-dialog-table .DWD-table > div > div:first-child {
  background: linear-gradient(180deg, #f0f6fc, #e6f0fa);
  color: #1a4a7a;
  font-weight: 700;
  font-size: 14px;
}

.dispatch-dialog-table .DWD-table-left-flex:nth-child(odd) > div:not(:first-child) {
  background: #f8fbff;
}

.dispatch-dialog-table .DWD-table-left-flex:nth-child(even) > div:not(:first-child) {
  background: #ffffff;
}

.dispatch-dialog-table .DWD-table-left-title > div:first-child {
  background: linear-gradient(180deg, #1a4a7a, #1e5a96);
}

.dispatch-dialog-table .DWD-table {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #c8ddf0;
}

.dispatch-dialog-table .DWD-table > div > div {
  border-right: 1px solid #dde9f5;
  border-bottom: 1px solid #dde9f5;
  border-top: none;
  border-left: none;
}

.dispatch-compare-cards {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 12px;
}

.dispatch-compare-card-new {
  border-radius: 12px;
  border: 1px solid #dde9f5;
  overflow: hidden;
  background: #f8fbff;
}

.dispatch-compare-card-new--final {
  border-color: #c8ddf0;
  background: #f0f7ff;
}

.dispatch-compare-card-header {
  padding: 10px 14px;
  background: linear-gradient(135deg, #1a4a7a, #1e6aaa);
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.dispatch-compare-card-new--final .dispatch-compare-card-header {
  background: linear-gradient(135deg, #0f6b3a, #158a4a);
}

.dispatch-compare-card-body {
  padding: 8px 0;
}

.dispatch-compare-card-row {
  display: flex;
  align-items: center;
  min-height: 36px;
  padding: 4px 14px;
  border-bottom: 1px solid #c8d8ea;
}

.dispatch-compare-card-row:last-child {
  border-bottom: none;
}

.dispatch-compare-card-label {
  flex: 0 0 72px;
  font-size: 13px;
  font-weight: 600;
  color: #5a7a9a;
}

.dispatch-compare-card-value {
  flex: 1;
  font-size: 14px;
  font-weight: 700;
  color: #0a1e30;
  word-break: break-all;
}

.dispatch-dialog-figure {
  margin-top: 16px;
  padding: 12px 14px;
  background: #f8fbff;
  border: 1px solid #dde9f5;
  border-radius: 10px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
}

.dispatch-dialog-figure .DetailsWater-img-text {
  font-size: 13px;
  font-weight: 600;
  color: #5a7a9a;
}

.billOperationRecord /deep/ .dispatch-dialog {
  border-radius: 14px;
  overflow: hidden;
}

.billOperationRecord /deep/ .dispatch-dialog .el-dialog__header {
  padding: 18px 24px;
  border-bottom: 1px solid rgba(220, 230, 240, 0.9);
  background: #f8fbff;
}

.billOperationRecord /deep/ .dispatch-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
}

.billOperationRecord /deep/ .dispatch-dialog .el-dialog__body {
  padding: 20px 24px 24px;
}

.billOperationRecord /deep/ .dispatch-dialog-input-row .el-input {
  width: 100%;
}

.billOperationRecord /deep/ .dispatch-dialog-input-row .el-input__inner {
  border: none;
  padding: 0;
  height: 34px;
  line-height: 34px;
}

.billOperationRecord /deep/ .dispatch-dialog-input-row .el-input__count .el-input__count-inner {
  background: transparent;
}

.billOperationRecord /deep/ .dispatch-form-grid .el-select {
  width: 100%;
}

.billOperationRecord /deep/ .dispatch-form-grid .el-select .el-input__inner {
  height: 48px;
  line-height: 48px;
  border: 1.5px solid #a8c8f0;
  border-radius: 8px;
  background: #ffffff;
  color: #0a1e30;
  font-size: 15px;
  font-weight: 600;
}

.billOperationRecord /deep/ .dispatch-form-grid .el-select .el-input__inner:focus {
  border-color: #178bff;
  box-shadow: 0 0 0 3px rgba(23, 139, 255, 0.12);
}

.billOperationRecord /deep/ .dispatch-form-grid .el-select .el-input__icon {
  line-height: 48px;
  color: #178bff;
  font-size: 15px;
}

.car-number-add {
  /* text-transform: uppercase; */
}

.billOperationRecord-table {
  padding: 18px 20px 0;
  border: 1px solid rgba(202, 220, 238, 0.9);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 28px rgba(36, 93, 150, 0.08);
}

.public_singleMenu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.pulic_operatArea_now:hover,
.public_operatArea_yesterday:hover {
  background-color: #ccc;
}

/* 新增--列表宽度 */
.billOperationRecord .systemCodePC-add-code-table-li-ipt {
  flex: 1.5;
}

.fontBlue {
  color: rgba(25, 159, 255, 1) !important;
}

.public_oparetionBlock_Menu .pulic_carNumber {
  margin-top: 6px;
  height: 40px;
  line-height: 40px;
  box-sizing: border-box;
  font-size: 14px;
  display: inline-block;
}

.billOperationRecord .public_oparetionBlock_Menu {
  height: 45px;
  align-items: center;
}

.billOperationRecord {
  min-height: 100%;
  padding: 16px 18px 22px;
  background:
    radial-gradient(circle at 0 0, rgba(25, 159, 255, 0.1), transparent 260px),
    linear-gradient(180deg, #f4f8fc 0%, #eef3f8 100%);
}

.billOperationRecord .dispatch-filter-card {
  margin-bottom: 10px;
  padding: 16px 22px 18px;
  border: 1px solid rgba(202, 220, 238, 0.9);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 28px rgba(36, 93, 150, 0.1);
}

.billOperationRecord .dispatch-section-wrap {
  width: 100%;
  margin-bottom: 10px;
}

.billOperationRecord .dispatch-section-head {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-left: 14px;
}

.billOperationRecord .dispatch-section-head::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  width: 4px;
  height: 22px;
  border-radius: 4px;
  transform: translateY(-50%);
  background: linear-gradient(180deg, #199fff 0%, #08d691 100%);
}

.billOperationRecord .dispatch-section-title {
  margin: 0;
  color: #20364d;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
}

.billOperationRecord .dispatch-section-desc {
  margin: 6px 0 0;
  color: #7a8da0;
  font-size: 13px;
  line-height: 20px;
}

.billOperationRecord .dispatch-section-meta {
  margin-left: 16px;
  color: #5f7b97;
  font-size: 13px;
  white-space: nowrap;
}

.billOperationRecord .dispatch-table-head {
  gap: 16px;
  margin-bottom: 10px;
}

.billOperationRecord .dispatch-table-head .dispatch-section-title {
  margin-top: 6px;
}

.billOperationRecord .dispatch-table-tools {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  margin-left: auto;
}

.billOperationRecord .dispatch-table-tip {
  padding-right: 8px;
  color: #7a8da0;
  font-size: 13px;
}

.billOperationRecord .dispatch-table-meta {
  padding-right: 8px;
  color: #5f7b97;
  font-size: 13px;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 12px 18px;
  padding: 14px 16px;
  border-radius: 10px;
  background: #f8fbfe;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange > div {
  min-width: 0;
}

.billOperationRecord .dispatch-filter-group-title {
  display: flex;
  align-items: center;
  min-height: 22px;
  color: #4d6985;
  font-size: 13px;
  font-weight: 700;
}

.billOperationRecord .dispatch-filter-group-title::before {
  content: '';
  width: 6px;
  height: 6px;
  margin-right: 8px;
  border-radius: 50%;
  background: #199fff;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange .public_oparetionBlock_Menu {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  height: auto;
  margin-right: 0;
  margin-bottom: 0;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange .public_lbSty {
  flex: 0 0 84px;
  color: #1a2e40;
  font-weight: 600;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange .public_optionSty,
.billOperationRecord .dispatch-filter-card > .public_criteriaRange .el-select,
.billOperationRecord .dispatch-filter-card > .public_criteriaRange .el-date-editor,
.billOperationRecord .dispatch-filter-card > .public_criteriaRange .el-input {
  width: auto;
  min-width: 0;
  margin-right: 0;
  flex: 1;
}

.billOperationRecord .dispatch-filter-card > .public_criteriaRange .pulic_carNumber {
  width: 100%;
}

.billOperationRecord .dispatch-filter-card .dispatch-secondary-filters .public_lbSty {
  color: #1a2e40;
  font-weight: 600;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 18px;
  padding: 0;
  background: transparent;
}

.billOperationRecord .dispatch-filter-card .dispatch-secondary-filters .public_oparetionBlock_Menu {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin-right: 0;
  margin-bottom: 0;
}

.billOperationRecord .dispatch-filter-card .dispatch-secondary-filters .dispatch-filter-group-title {
  width: 100%;
}

.billOperationRecord .dispatch-date-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 12px;
  margin-top: 12px;
  padding: 12px 16px;
  border: 1px solid #eaf1f8;
  border-radius: 10px;
  background: #fbfdff;
}

.billOperationRecord .dispatch-date-label {
  color: #4d6985;
  font-size: 13px;
  font-weight: 700;
}

.billOperationRecord .dispatch-date-meta {
  margin-left: auto;
  color: #7a8da0;
  font-size: 13px;
}

.billOperationRecord .dispatch-date-row .public_operatArea_timePicker {
  margin-left: 0;
}

.billOperationRecord .dispatch-action-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px 20px;
  margin-top: 12px;
  padding: 12px 16px;
  border-radius: 10px;
  background: linear-gradient(90deg, #f8fbfe 0%, #ffffff 100%);
}

.billOperationRecord .dispatch-secondary-filters {
  flex: 1;
  min-width: 420px;
}

.billOperationRecord .dispatch-operat-btn {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-left: auto;
}

.billOperationRecord .dispatch-operat-btn button,
.billOperationRecord .dispatch-operat-btn .el-button {
  margin-left: 0;
}

.billOperationRecord .dispatch-reset-btn {
  border-color: #d9e5f2;
  color: #4d6985;
  background: #fff;
}

.billOperationRecord .dispatch-query-btn {
  box-shadow: 0 8px 18px rgba(25, 159, 255, 0.18);
}

.billOperationRecord .dispatch-utility-btn {
  opacity: 0.92;
}

.billOperationRecord .public_statisticsInfo {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 12px;
  height: auto;
  margin-bottom: 0;
  padding: 18px 18px 16px;
  border: 1px solid rgba(202, 220, 238, 0.9);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 10px 28px rgba(36, 93, 150, 0.08);
}

.billOperationRecord .billDetails-statistics {
  display: flex;
  align-items: center;
  flex: 1 1 280px;
  min-height: 112px;
  height: auto;
  margin-right: 0 !important;
  padding: 16px 18px;
  border: 1px solid #edf3f9;
  border-radius: 10px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fbfe 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.billOperationRecord .billDetails-statistics .public_statisticsContent {
  display: flex;
  flex: 0 0 72px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.billOperationRecord .billDetails-statistics .billDetails-ul {
  flex: 1;
  min-width: 0;
  margin: 0 0 0 18px !important;
  padding: 0;
}

.billOperationRecord .billDetails-statistics .pulic_statistics_titlt {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: end;
  column-gap: 12px;
  row-gap: 6px;
  line-height: 1.4;
}

.billOperationRecord .billDetails-statistics .totolTitle {
  min-width: 0;
  line-height: 22px;
}

.billOperationRecord .billDetails-statistics .Amount,
.billOperationRecord .billDetails-statistics .singular {
  flex-shrink: 0;
  padding-left: 12px;
  line-height: 1;
  white-space: nowrap;
  text-align: right;
}

.billOperationRecord th,
.billOperationRecord td {
  text-align: center !important;
}

.billOperationRecord /deep/ .el-table {
  border-radius: 10px;
  overflow: hidden;
}

.billOperationRecord /deep/ .el-table th {
  height: 44px;
}

.billOperationRecord /deep/ .el-table td {
  border-bottom-color: #edf3f9;
}

.billOperationRecord /deep/ .el-table__row:hover > td {
  background-color: #f4faff !important;
}

.billOperationRecord .dispatch-cell-main,
.billOperationRecord .dispatch-cell-sub {
  margin: 0;
  line-height: 18px;
}

.billOperationRecord .dispatch-cell-block {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.billOperationRecord .dispatch-cell-sub-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.billOperationRecord .dispatch-table-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.billOperationRecord .dispatch-table-actions .el-button {
  margin-left: 0;
}

.billOperationRecord .dispatch-more-btn {
  background: #f2f8ff;
  border-color: #d7e8fb;
  color: #2d70b3;
}

.billOperationRecord .dispatch-action-menu {
  min-width: 140px;
}

.billOperationRecord .dispatch-empty-state {
  padding: 28px 12px;
}

.billOperationRecord .dispatch-empty-title {
  color: #31465c;
  font-size: 15px;
  font-weight: 700;
}

.billOperationRecord .dispatch-empty-desc {
  margin-top: 8px;
  color: #7a8da0;
  font-size: 13px;
  line-height: 20px;
}

.billOperationRecord .dispatch-empty-action {
  margin-top: 14px;
}

.billOperationRecord .dispatch-cell-main {
  color: #24384d;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.billOperationRecord .dispatch-cell-sub {
  color: #6f8396;
  font-size: 13px;
}

.billOperationRecord .public_tableColumn >>> .el-table__body tr {
  cursor: pointer;
}

.billOperationRecord .public_tableColumn >>> .el-table__body tr:hover > td {
  background: #f3f9ff !important;
}

.billOperationRecord .dispatch-header-tip {
  margin-left: 4px;
  color: #178bff;
  font-size: 13px;
  cursor: help;
}

.billOperationRecord .dispatch-detail-link {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  color: #178bff;
  font-size: 13px;
  line-height: 18px;
  cursor: pointer;
}

.billOperationRecord .dispatch-detail-link:hover {
  text-decoration: underline;
}

.billOperationRecord .dispatch-cell-sub-card,
.billOperationRecord .dispatch-cell-sub-chip {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  min-height: 28px;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 8px;
  line-height: 18px;
  box-sizing: border-box;
}

.billOperationRecord .dispatch-cell-block-customer .dispatch-cell-main {
  color: #0d2a42;
  font-weight: 700;
}

.billOperationRecord .dispatch-cell-block-customer .dispatch-cell-sub-card {
  background: #f5f9ff;
  border: 1px solid #dceafb;
  color: #2a5f8f;
  font-weight: 600;
}

.billOperationRecord .dispatch-cell-sub-card-muted {
  background: #f8fafc;
  border-color: #e6edf5;
  color: #8495a6;
}

.billOperationRecord .dispatch-cell-block-transport .dispatch-cell-main {
  color: #2f5a43;
}

.billOperationRecord .dispatch-cell-block-transport .dispatch-cell-sub-chip {
  background: #f4fbf6;
  border: 1px solid #d8eee0;
  color: #5f7d69;
}

.billOperationRecord .dispatch-cell-sub-weight {
  background: #fff8ef;
  border-color: #f4dfba;
  color: #9a6c21;
}

.billOperationRecord .dispatch-cell-sub-chip-factory {
  background: #f0f7ff;
  border: 1px solid #c8ddf0;
  color: #1a4a7a;
  font-weight: 600;
}

.billOperationRecord .dispatch-filter-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid #c8ddf0;
  background: #f0f7ff;
  color: #178bff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: background 0.2s, border-color 0.2s;
}

.billOperationRecord .dispatch-filter-toggle:hover {
  background: #dbeeff;
  border-color: #178bff;
}

.billOperationRecord .dispatch-stats-bar {
  display: flex;
  align-items: center;
  gap: 0;
  padding: 10px 18px;
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #dde9f5;
  box-shadow: 0 2px 8px rgba(18, 52, 77, 0.05);
  flex-wrap: wrap;
}

.billOperationRecord .dispatch-stats-item {
  display: flex;
  align-items: baseline;
  gap: 5px;
  padding: 4px 20px;
  flex: 1;
  min-width: 0;
}

.billOperationRecord .dispatch-stats-divider {
  width: 1px;
  height: 28px;
  background: #dde9f5;
  flex-shrink: 0;
}

.billOperationRecord .dispatch-stats-label {
  font-size: 13px;
  color: #1a2e40;
  font-weight: 700;
  white-space: nowrap;
}

.billOperationRecord .dispatch-stats-value {
  font-size: 20px;
  font-weight: 700;
  color: #0a1e30;
  line-height: 1;
}

.billOperationRecord .dispatch-stats-value--blue { color: #178bff; }
.billOperationRecord .dispatch-stats-value--green { color: #08c98a; }
.billOperationRecord .dispatch-stats-value--orange { color: #f5720a; }

.billOperationRecord .dispatch-stats-unit {
  font-size: 13px;
  color: #1a2e40;
  font-weight: 600;
  white-space: nowrap;
}

.billOperationRecord .dispatch-customer-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.billOperationRecord .dispatch-customer-name {
  font-size: 14px;
  font-weight: 700;
  color: #0a1e30;
  line-height: 1.4;
}

.billOperationRecord .dispatch-customer-phone {
  font-size: 13px;
  font-weight: 600;
  color: #3a6080;
  line-height: 1.4;
}

.billOperationRecord .dispatch-weight-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.billOperationRecord .dispatch-cell-material-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.billOperationRecord .dispatch-material-title {
  padding: 1px 6px;
  border-radius: 10px;
  background: #d8eee0;
  color: #2f5a43;
  font-weight: 700;
}

.billOperationRecord .dispatch-weight-title {
  padding: 1px 6px;
  border-radius: 10px;
  background: #f2e1bd;
  color: #7a4f12;
  font-weight: 700;
}

.billOperationRecord .dispatch-status-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.billOperationRecord .dispatch-status-primary {
  padding: 2px 10px;
  border-radius: 12px;
  background: linear-gradient(90deg, #199fff 0%, #47b4ff 100%);
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
}

.billOperationRecord .dispatch-status-list,
.billOperationRecord .dispatch-type-cell {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 4px 6px;
  line-height: 18px;
}

.billOperationRecord .dispatch-status-list span {
  padding: 1px 6px;
  border-radius: 9px;
  background: #eef6ff;
  color: #45647f;
  white-space: nowrap;
  font-size: 12px;
}

.billOperationRecord .dispatch-status-chip-normal {
  background: #edf9f1 !important;
  color: #23925f !important;
}

.billOperationRecord .dispatch-status-chip-alert {
  background: #fff2f1 !important;
  color: #d44f3e !important;
}

.billOperationRecord .dispatch-type-cell .orderBtn {
  width: 52px;
  height: 24px;
  line-height: 24px;
  font-size: 13px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
}

.billOperationRecord .dispatch-type-cell .imgStatistics {
  width: 36px;
  height: 36px;
}

/* 统计 START*/
.imgStatistics {
  width: 40px;
  height: 40px;
}

.payType {
  font-size: 20px;
  /* font-size: 24px; */
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(102, 102, 102, 1);
  line-height: 26px;
}

.singular {
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  vertical-align: middle;
  padding-left: 10px;
}

.Amount {
  font-size: 32px;
  font-family: Microsoft YaHei;
  /* font-weight:bold; */
  line-height: 30px;
  vertical-align: middle;
  padding-left: 10px;
}

.pulic_statistics_titlt {
  line-height: 40px;
}

.Customer-upload-bd {
  padding: 20px 0;
}

.disabled .el-upload--picture-card {
  display: none;
}

/* 统计 END*/
.orderBtn {
  display: inline-block;
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
}

.orderBtnType1 {
  background-color: #68d6a8;
}

.orderBtnType2 {
  background-color: #e2af07;
}
.orderBtn1 {
  background-color:rgb(9, 117, 218);
}
.orderBtn2 {
  background-color:red;
}

@media screen and (max-width: 1600px) {
  .billOperationRecord .dispatch-filter-card > .public_criteriaRange {
    grid-template-columns: repeat(2, minmax(280px, 1fr));
  }
}

@media screen and (max-width: 1280px) {
  .billOperationRecord .dispatch-section-head {
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px 12px;
  }

  .billOperationRecord .dispatch-section-meta,
  .billOperationRecord .dispatch-table-tools,
  .billOperationRecord .dispatch-date-meta {
    margin-left: 0;
  }

  .billOperationRecord .dispatch-table-tools {
    width: 100%;
    align-items: flex-start;
  }

  .billOperationRecord .dispatch-secondary-filters {
    min-width: 100%;
  }
}

@media screen and (max-width: 960px) {
  .billOperationRecord .dispatch-filter-card > .public_criteriaRange {
    grid-template-columns: minmax(0, 1fr);
  }

  .billOperationRecord .dispatch-filter-card > .public_criteriaRange .public_lbSty,
  .billOperationRecord .dispatch-filter-card .dispatch-secondary-filters .public_lbSty {
    flex: 0 0 76px;
  }

  .billOperationRecord .dispatch-action-row,
  .billOperationRecord .dispatch-date-row {
    padding: 12px;
  }

  .billOperationRecord .dispatch-operat-btn {
    width: 100%;
    justify-content: flex-start;
  }

  .billOperationRecord .dispatch-table-head {
    gap: 12px;
  }

  .dispatch-transport-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .dispatch-dialog-footer,
  .dispatch-dialog-footer-split {
    flex-direction: column;
    align-items: stretch;
  }

  .dispatch-dialog-footer-actions {
    width: 100%;
    justify-content: flex-end;
  }

  .dispatch-form-feedback {
    flex-direction: column;
  }

  .dispatch-form-feedback span:last-child {
    text-align: left;
  }

  .dispatch-form-feedback-emphasis,
  .dispatch-form-feedback-emphasis.is-primary {
    justify-content: flex-start;
    text-align: left;
  }
}
</style>

<style>
.dispatch-dialog {
  border-radius: 14px;
  overflow: hidden;
}

.dispatch-dialog .el-dialog__header {
  padding: 18px 24px;
  border-bottom: 1px solid rgba(220, 230, 240, 0.9);
  background: #f8fbff;
}

.dispatch-dialog .el-dialog__title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2d3d;
}

.dispatch-dialog .el-dialog__body {
  padding: 20px 24px 24px;
}

.dispatch-dialog .dispatch-dialog-input-row .el-input {
  width: 100%;
}

.dispatch-dialog .dispatch-dialog-input-row .el-input__inner {
  border: none;
  padding: 0;
  height: 34px;
  line-height: 34px;
}

.dispatch-dialog .dispatch-dialog-input-row .el-input__count .el-input__count-inner {
  background: transparent;
}

.dispatch-dialog .dispatch-form-grid .el-select {
  width: 100%;
}

.dispatch-dialog .dispatch-form-grid .dispatch-complete-material-select {
  display: block;
  width: 100%;
  height: 46px;
  line-height: 46px;
}

.dispatch-dialog .dispatch-form-grid .dispatch-complete-material-field {
  padding: 0 10px;
  background: #ffffff;
}

.dispatch-dialog .dispatch-form-grid .dispatch-complete-material-select .el-input {
  display: block;
  width: 100%;
  height: 46px;
  line-height: 46px;
}

.dispatch-dialog .dispatch-form-grid .dispatch-complete-material-select .el-input__inner,
.dispatch-dialog .dispatch-form-grid .dispatch-complete-material-select .el-input__inner:hover {
  width: 100%;
  height: 46px;
  line-height: 46px;
  padding: 0 30px 0 0;
  border: 0 !important;
  border-radius: 0;
  background: #ffffff;
  text-align: left;
  box-shadow: none !important;
  box-sizing: border-box;
}

.dispatch-dialog .dispatch-form-grid .dispatch-complete-material-select .el-input__inner:focus {
  border: 0 !important;
  box-shadow: none !important;
}

.dispatch-dialog .dispatch-form-grid .dispatch-complete-material-select .el-input__suffix {
  right: 8px;
  display: flex;
  align-items: center;
  height: 100%;
}

.dispatch-dialog .dispatch-form-grid .dispatch-complete-material-select .el-input__icon {
  line-height: 46px;
}
</style>
<style>
.sales-dispatch-management-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.sales-dispatch-management-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.sales-dispatch-management-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.sales-dispatch-management-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.sales-dispatch-management-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
